{
  "AcceptButton": {
    "AbortOption": "Nei",
    "AlternativeButtonLabel": "Lagre",
    "ConfirmDeleteQuestion": "Er du sikker?",
    "ConfirmOption": "Ja",
    "DefaultButtonLabel": "Godkjenn"
  },
  "AddExternalLinkModal": {
    "AddAndClose": "Legg til og lukk",
    "AddAndNew": "Legg til og ny",
    "AddLink": "Legg til lenke",
    "Anchor": "Anker",
    "Auto": "Auto",
    "FullUrlOrId": "Komplett URL",
    "InvalidForm": "Ugyldig skjema",
    "LinkAdded": "Lenke er lagt til",
    "NewCommonTab": "Ny felles fane",
    "NewTab": "Ny fane",
    "SameTab": "Samme fane",
    "TitleOnUrl": "Tittel på URL"
  },
  "AnalyticsView": {
    "Analysis": "Analyse",
    "AnalysisTable": {
      "EditorUrl": "Editor-URL",
      "PageLocale": "Sidespråk",
      "PageStatus": "Side-status",
      "PageTitle": "Sidetittel",
      "PortalUrl": "Portal-URL"
    },
    "BlockTypeUsageAnalyzer": {
      "DescriptiveText": "Her kan du se hvor forskjellige modultyper er brukt på ditt nettsted. Velg en modultype fra nedtrekksmenyen og klikk på 'Kjør analyse' for å se resultatene.",
      "RunAnalysisButton": "Kjør analyse"
    },
    "WhatPagesUseWhatModules": "Hvilke sider bruker hvilke moduler"
  },
  "ArticleTitleBlock": {
    "Heading": "Overskrift; trenger kun angis om den skal avvike fra sides tittel (se sideinnstillinger)",
    "HideInsertTitle": "Skjul stikktittel",
    "InsertTitle": "Stikktittel",
    "Preamble": "Ingress",
    "SyncPageDescription": "Bruk sidens beskrivelse som ingress"
  },
  "AttachmentsBlock": {
    "MaxRows": "Maks antall rader (før vis alle knapp vises)",
    "SearchFieldText": "Tekst over søkefelt",
    "ShowSearchField": "Vis enkelt søkefelt for søk i liste"
  },
  "BannerBlock": {
    "AddMediaButtons": {
      "addAudio": "Lydfil",
      "addIcon": "Legg inn ikon",
      "addSvg": "SVG"
    },
    "AddSlideshowImagesDescription": "MERK: Det vises maksimalt 5 bilder i slideshowet; hovedbildet og de 4 første eller tilfeldige fra listen nedenfor.",
    "AddSlideshowImagesRandomizeLabel": "Vis i tilfeldig rekkefølge.",
    "AddSlideshowImagesLabel": "Legg til flere bilder som slideshow ({{count}})",
    "AdvancedSettings": {
      "dmSearch": {
        "Label": "Inkluder eksternt digitaltmuseum-søkefelt",
        "completeUrl": {
          "HelperText": "Lim inn hele URLen etter å ha innstilt søket i DigitaltMuseum.",
          "Label": "DigitaltMuseum søkekontekst (url encoded)",
          "Placeholder": "Komplett URL fra DM"
        },
        "labelButton": {
          "Label": "Tekst på søkeknapp",
          "Placeholder": "Søk"
        },
        "labelPlaceholder": {
          "Label": "Tekst i søkefelt",
          "Placeholder": "Søk på DigitaltMuseum.no"
        }
      },
      "effect": {
        "HelperText": "Kan ikke kombineres med beta:slides",
        "Label": "Spesial-effekt (vises kun i sluttportal)",
        "options": {
          "": "Ingen effekt",
          "parallax": "Bakgrunnsbilde som ikke scroller (parallax..)",
          "zoom": "Zoom bakgrunnsbildet langsomt inn",
          "effect-media-contain": "Vis hele bildet alltid",
          "effect-media-contain-on-phone": "Vis hele bildet på mobil stående",
          "effect-media-contain-on-large": "Vis hele bildet på større skjermer (f.eks. desktop)"
        }
      },
      "svgLogo": {
        "HelperText": "SVG logo som alternativ til tittel",
        "Label": "SVG Logo"
      },
      "tocId": {
        "HelperText": "ID for internlenke",
        "Label": "ID"
      }
    },
    "BannerBlockTextEditor": {
      "recommendationLabel": "Vi anbefaler minimalt med tekst her."
    },
    "BannerBlockTextLineColorSelector": {
      "label": "Tekstlinjer",
      "line-dark": "Mørk semitransparent linje",
      "line-light": "Lys semitransparent linje"
    },
    "BannerMediaBackground": {
      "Remove": "Fjern bilde",
      "gradient": "Gradient",
      "hideVideoControls": "Skjul video-controller",
      "label": "Legg til mediebakgrunn",
      "localCaption": "Lokal bildetekst",
      "localCaptionDescription": "Overstyrer global bildetekst",
      "mediaCredits": "Mediakreditering",
      "mediaCreditsDescription": "Mediakreditering vises diskret",
      "overlay": "Overlay",
      "vignette": "Vignett",
      "usePosterImage": "Vis oppstartsbilde (plakat/cover)  frem til video starter",
      "skin": "Farge på vignett, gradient eller overlay (hvis annet enn sort)"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "center": "Midtstilt",
        "default": "Auto",
        "left": "Venstre",
        "right": "Høyre",
        "tooltip": "Tekstjustering"
      },
      "BannerBlockTitleSizeSelector": {
        "default": "Auto",
        "large": "Større",
        "medium": "Medium",
        "normal": "Normal",
        "small": "Mindre",
        "tooltip": "Tekststørrelse",
        "xl": "XL",
        "xxl": "XXL"
      },
      "BannerBlockTitleTransformationSelector": {
        "capitalize": "Capitalize",
        "lowercase": "Lowercase",
        "normal": "Normal",
        "tooltip": "Transformasjon",
        "uppercase": "Uppercase"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "bottom": "Bunn",
        "default": "Auto",
        "justify": "Justify",
        "middle": "Sentrert",
        "tooltip": "Vertikal justering",
        "top": "Topp"
      },
      "BannerBlockTitleWeightSelector": {
        "black": "Black",
        "bold": "Fet",
        "default": "Auto",
        "extrabold": "Extrabold",
        "light": "Light",
        "medium": "Medium",
        "normal": "Normal",
        "regular": "Regular",
        "semibold": "Semibold",
        "thin": "Tynn",
        "tooltip": "Tykkelse"
      },
      "HideTitleLabel": "Skjul",
      "RunningHeadLabel": "Stikktittel",
      "SetTitleAsH1": "Sett tittel som H1",
      "TitleLabel": "Tittel"
    },
    "LinksLabel": "Lenker/Knapper",
    "CloseSlideshowImagesButton": "Lukk slideshow",
    "MoreSettingsLabel": "Flere innstillinger",
    "NextButtonLabel": "Vis PIL NED til neste banner eller seksjon (f.eks. fra toppbanner)",
    "VideoBannerExplanation": "Video i banner bruker kun som bakgrunnseffekt, og avspilles automatisk uten lyd, utfallende, i loop og uten controllere (pause, fullskjerm osv.). Ved behov for vanlige videofunksjoner, bruk Videomodul i Innholdsseksjon.",
    "legacySettings": "Semitransparente innstillinger kan kun brukes i kombinasjon med 'Tekst på bilde'-layout. PS. Du kan også bruke layoutene 'Boks' eller 'Tekstlinjer'. Disse kan fargesettes med skins.",
    "transparent": "Transparent bakgrunn (Fjerner bakgrunnsfargen i valgt tema, behholder tekstfarger)",
    "useModuleContentBackgound": "Semitransparent boks bak tekst",
    "useTextbackgound": "Semitransparente tekstlinjer"
  },
  "ButtonCollection": {
    "ShowLess": "Vis mindre",
    "ShowMore": "Vis mer"
  },
  "BylineBlock": {
    "Author": "Forfatter",
    "ChoosePerson": "Velg person",
    "Description": "Beskrivelse",
    "Employee": "Ansatt",
    "FindImage": "Finn bilde",
    "Manual": "Manuell",
    "Person": "Person-kort",
    "PersonCardsNotSupported": "Personkort er ikke støttet. Plukk en ansatt i stedet eller bruk manuell-mode",
    "UploadImage": "Last opp bilde",
    "WrittenBy": "Skrevet av"
  },
  "CaptionInput": {
    "CaptionLabel": "Bildetekst",
    "HideCaption": "Skjul bildetekst"
  },
  "CardEditor": {
    "BothInternalAndExternal": "NB! Dette kortet lenker både til en side og til en annen url. Det anbefales å fjerne en av dem slik at kortet blir entydig internt eller eksternt. Hvis begge deler forblir angitt vil ekstern url benyttes fremfor sidelenke hvis man klikker på kortet på hjemmesiden",
    "Category": "Velg kort-kategori",
    "Description": "Beskrivelse (hold det kort!)",
    "EditCard": "Rediger kort",
    "FindImage": "Finn bilde",
    "Footer": "Bunntekst 2 (dato el.)",
    "FooterLocation": "Bunntekst 1 (sted el.)",
    "ImageFieldTitle": "Velg bilde",
    "InternalCard": "Internt kort: Lenke til en side på nettstedet",
    "NoCategory": "Ingen",
    "Page": "Sidelenke",
    "RemoveImage": "Fjern bilde",
    "RemovePage": "Fjern side",
    "SelectPage": "Velg side",
    "SelectSkin": "Velg farge",
    "SwapImage": "Bytt bilde",
    "Title": "Tittel",
    "Url": "Eksternt kort: Lenke til annet nettsted  el.",
    "UrlDescription": "Bruk komplette URLer. Eksempel: https://www.museum.no/side  ",
    "UrlExternal": "Lenke (ekstern)",
    "callToActionButtonText": "Les mer tekst (call-to-action)"
  },
  "CardModuleBlock": {
    "Auto": "Auto",
    "AutoOldSettings": "Innstillinger fra Museum24 1.0 (foreløpig ikke justerbare i 2.0)",
    "CardSizeSelector": {
      "collapsed": "Collapsed",
      "label": "Velg størrelse for alle kort",
      "large": "Stor",
      "medium": "Middels",
      "small": "Liten",
      "undefined": "Ikke satt"
    },
    "MediaSizeSelector": {
      "label": "Sett fast Bilde-ratio for alle kort",
      "16-9": "16:9",
      "4-3": "4:3",
      "3-2": "3:2",
      "1-1": "1:1",
      "2-3": "2:3",
      "3-4": "3:4",
      "free": "Fri",
      "undefined": "Ikke satt (auto)"
    },
    "GridMobileBehaviourLabel": "Rutenettoppførsel på mobil",
    "ListMobileBehaviourLabel": "Listeoppførsel på mobil",
    "GridSizeLabel": "Rutenett størrelse",
    "GroupByLabel": "Gruppering av kort (se resultat i sluttportal)",
    "Manual": "Manuell",
    "category": "Kategori",
    "events": "Dato (1.0)",
    "footerLocation": "Bunntekst 1 (sted el.)",
    "footerText": "Bunntekst 2 (dato el.)",
    "includeGlobalListSearch": "Gjør listesøk globalt",
    "includeListSearch": "Inkluder listesøkefelt",
    "listSearchText": "Tekst i søkefelt",
    "location": "Sted (1.0)",
    "metadataformat": "Metadataformat",
    "noMeta": "Skjul metadata/bunntekst",
    "place": "Museum (nettsted)",
    "ChangeCard": "Endre kort (globalt)",
    "ChangesSaved": "Endringer er lagret. Du må lagre siden på nytt for å se endringene i forhåndsvisning. I sluttportal vil de være på plass allerede."
  },
  "CardModuleBlockCardSearch": {
    "FilterCategories": "Kategorier",
    "FilterTags": "Stikkord",
    "FooterLink": "Knapp nederst (link videre)",
    "Metadata": "Velg hvilke metadata/felter som skal vises på kortene",
    "Order": "Sorteringsrekkefølge",
    "OrderBy": "Sortering",
    "OrderBySelector": {
      "date": "Publiseringsdato",
      "event": "Kalenderdato",
      "false": "Manuell",
      "title": "Alfabetisk: Tittel"
    },
    "OrderSelector": {
      "asc": "Stigende",
      "desc": "Synkende"
    },
    "Rows": "Maks antall",
    "Title": "Kortsøk"
  },
  "CardModuleBlockItem": {
    "GridSizeSelector": {
      "collapsed": "Minimert",
      "default": "Ikke satt",
      "label": "Velg størrelse",
      "large": "Stor",
      "medium": "Middels",
      "small": "Liten"
    }
  },
  "CardModuleViewTypeSelector": {
    "CardModuleViewTypeVariant": {
      "articles": "Artikkelliste",
      "auto": "Auto",
      "grid": "Rutenett",
      "horizontal": "Horisontal scroll",
      "list": "Liste",
      "card": "Kort (Stående i full bredde)",
      "col-1": "Én kolonne på mobil (stående)"
    }
  },
  "CardsView": {
    "BlockType": {
      "article__card": "Kort",
      "article__person": "Personkort (NB! erstattet av 'Ansatte')"
    },
    "BlockTypeLabel": "Type:",
    "CategoriesInfo": "*Kortkategorier er de kategoriene som var i gamle Museum24. For ARRANGEMENT er det nå laget eget oppsett. ",
    "CategoriesInfoLinkText": "Les mer om det her.",
    "CategoriesLabel": "Kategorier*:",
    "CreateCard": "Opprett nytt kort",
    "Title": "Kort",
    "PersonsInfo": "<strong>NB! Personkort er ersattet av 'Ansatte' som du finner i ansatte-galleriet i hovedmenyen.</strong> <br/> I Museum24 2.0 forvaltes ansattinformasjon i ansatte-galleriet og de ansatte vises på nettsidene med ansatte-moduler. <br/> Personkort vil imidlertid ligge i Museum24 og vises på nettstedet (via kort-moduler) frem til man har fått ersattet disse med ansatte-moduler. Du vil ikke kunne opprette nye personkort og heller ikke redigere alle kontaktdata som opprinnelig lå i disse kortene.",
    "CardFilter": {
      "unpublished": "Ikke publisert",
      "internal_card": "Interne kort",
      "all": "Alle",
      "external_card": "Eksterne kort"
    }
  },
  "CommonBlockContent": {
    "Alignment": {
      "Tooltip": "Tekstjustering",
      "auto": "Auto",
      "center": "Midtstilt",
      "left": "Venstre (midtspalte)",
      "module": "Følg modulbredde"
    },
    "BlockSettings": "Tittel og beskrivelse",
    "FormLabels": {
      "AnchorID": "Anker",
      "Body": "Beskrivelse"
    }
  },
  "CommonSectionContent": {
    "FormLabels": {
      "AnchorID": "Anker",
      "Arrows": "Vis piler",
      "BackgroundMedia": "Mediabakgrunn",
      "BackgroundPosition": "Bakgrunssposisjon",
      "CarouselSettings": "Innstillinger for karusellvisning",
      "CarouselAutoplay": "Autoplay",
      "CarouselAutoplaySpeed": "Autoplay-hastighet (millisekunder)",
      "CarouselTransition": "Overgangseffekt",
      "CssClass": "CSS-klasse",
      "Filter1": "Filter 1",
      "Filter2": "Filter 2",
      "MediaCredits": "Bildetekst/Fotograf/Lisens",
      "MobileBehavior": "Mobiloppførsel",
      "MobileBehaviorDescription": "Normalt vises to små moduler i bredden på mobil, øvrige størrelser vises i én kolonne.",
      "Modifier": "Rutenettstørrelse",
      "ModifierDescription": "Normal vises 4 små moduler i bredden på større skjermer. Her kan du endre på dette.",
      "PaddingBottom": "Mellomrom under seksjon",
      "PaddingTop": "Mellomrom over seksjon",
      "Spacing": "Mellomrom mellom bannere",
      "TextColor": "Tekstfarge",
      "Title": "Overskrift og ingress",
      "ToggleIntrosection": "Aktiver Scrollytell-seksjon",
      "ToggleVisibleTitle": "Vis tittel",
      "ToggleCenterTitle": "Sentrér tittel",
      "RemoveLeftPadding": "Fjern tekstmarg og bakgrunnsfarge i alle bannere (som har bilde øverst)"
    },
    "SectionSettings": "Seksjonsinnstillinger",
    "arrows": {
      "allways": "Alltid",
      "first": "Kun på første modul",
      "none": "Aldri"
    },
    "backgroundPosition": {
      "center": "Sentrert",
      "contain": "Tilpass",
      "top": "Topp"
    },
    "filter": {
      "animation-zoom": "Zoom-animasjon",
      "filter-blur": "Uskarp (Litt)",
      "filter-blur-2": "Uskarp 1",
      "filter-blur-3": "Uskarp 2",
      "filter-blur-5": "Uskarp 3",
      "filter-blur-10": "Uskarp 4",
      "filter-blur-15": "Uskarp 5",
      "filter-blur-20": "Uskarp 6",
      "filter-blur-30": "Uskarp 7",
      "filter-blur-50": "Uskarp 8 (Mye)",
      "filter-brightness": "Lysstyrke (Mørkt)",
      "filter-brightness-04": "Lysstyrke 1",
      "filter-brightness-05": "Lysstyrke 2",
      "filter-brightness-06": "Lysstyrke 3",
      "filter-brightness-07": "Lysstyrke 4",
      "filter-brightness-08": "Lysstyrke 5 (Lyst)",
      "filter-contrast": "Kontrast (Lav)",
      "filter-contrast-05": "Kontrast 1",
      "filter-contrast-08": "Kontrast 2 (Høy)",
      "filter-grayscale": "Svart-hvitt (Ingen farge)",
      "filter-grayscale-03": "Svart-hvitt 1",
      "filter-grayscale-05": "Svart-hvitt 2",
      "filter-grayscale-08": "Svart-hvitt 3 (Noe farge)",
      "filter-sepia": "Bruntone (sepia)",
      "filter-sepia-05": "Bruntone (sepia) 1",
      "filter-sepia-08": "Bruntone (sepia) 2"
    },
    "modifier": {
      "auto": "Auto (4 kolonner)",
      "grid33": "3 kolonner (én kolonne på mobil)"
    },
    "mobileBehaviors": {
      "auto": "Auto (2 kolonner)",
      "col-1": "Én kolonne på mobil (stående)"
    },
    "padding": {
      "0": "0",
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "5": "5",
      "6": "6",
      "10": "10",
      "auto": "Auto"
    },
    "spacing": {
      "0": "Ingen",
      "1": "Luft",
      "2": "Luft",
      "auto": "Auto",
      "line": "Linje"
    },
    "textColor": {
      "dark": "Mørk",
      "light": "Lys"
    },
    "transition": {
      "fade": "Fade",
      "slide": "Slide"
    }
  },
  "ContentView": {
    "backToEventsButtonLabel": "Tilbake til arrangementene",
    "backToPageTreeButtonLabel": "Tilbake til sidetreet",
    "eventsTitle": "Arrangementer",
    "importedPagesButtonLabel": "Importerte sider",
    "importedPagesDeleteStopped": "{{done}} av {{total}} sider ble slettet. Resten står igjen i listen.",
    "importedPagesDeleted": "{{count}} side(r) slettet",
    "importedPagesPublished": "{{count}} side(r) er publisert og lagt i sidetreet",
    "openImportedPagesHere": "Åpne her",
    "openImportedPagesInNewWindow": "Åpne i nytt vindu",
    "pagesTitle": "Sider"
  },
  "CreatePageModal": {
    "CreateEventFailed": "Arrangementet ble ikke opprettet",
    "CreateEventSuccessful": "Arrangementet er opprettet",
    "CreateNewEvent": "Opprett nytt arrangement",
    "CreateNewPage": "Opprett ny side",
    "CreateNewTemplate": "Opprett ny mal",
    "CreatePageFailed": "Siden ble ikke opprettet",
    "CreatePageSuccessful": "Siden er opprettet",
    "CreateTemplateFailed": "Malen ble ikke opprettet",
    "CreateTemplateSuccessful": "Malen er opprettet",
    "EventTitle": "Arrangementets tittel",
    "InvalidForm": "Ugyldig skjema",
    "NewEvent": "Nytt arrangement",
    "NewPage": "Ny side",
    "NewTemplate": "Ny mal",
    "NoSiteId": "Ingen site ID",
    "PageTitle": "Sidetittel",
    "Path": "Sti/lenke",
    "PathAlreadyExists": "Denne stien eksisterer allerede",
    "PathReservedForLanguage": "Denne url-stien er reservert for språkversjoner på nettstedet.",
    "PathExample": "(Eks. museum.no/en for engelsk osv.)",
    "Under": "Under",
    "UnsavedChangesWarning": "Du har ulagrede endringer! Endringene vil gå tapt hvis du går videre.",
    "save_and_close": "Lagre og lukk",
    "save_and_create_new": "Lagre og ny",
    "save_and_edit": "Lagre og rediger"
  },
  "CurrentPageInfo": {
    "ShowingXToYOutOfZItems_one": "Viser {{from, number}} - {{to, number}} av {{count, number}} element",
    "ShowingXToYOutOfZItems_other": "Viser {{from, number}} - {{to, number}} av {{count, number}} elementer"
  },
  "DMBlock": {
    "AddFilteringSortingForUsers": "Legg til filtrering/sortering for brukere",
    "AltDescriptionLabel": "Alternativ beskrivelse",
    "AltTitleLabel": "Alternativ tittel",
    "AlternativeFields": "Fyll inn alternativ tekst",
    "DigitalResources": "Digitale ressurser",
    "DMItemsLabel": "Velg objekter fra DM",
    "DMMuseumLabel": "Velg et museum fra DM",
    "DmLinkLabel": "Knapp under listen med valgfri lenke til relevant område på Digitalt Museum",
    "DmLink": "Komplett URL for Gå til DigitaltMuseum (knapp)",
    "DmLinkText": "Tekst på DigitaltMuseum-knapp",
    "EnableSearch": "Vis søkeboks for å søke i Digitalt Museum",
    "EndUserFilteringSorting": {
      "gradeFilter": "Trinn",
      "subjectFilter": "Fag",
      "ownerFilter": "Museum",
      "resourceTypeFilter": "Ressurstype",
      "sortBySelector": "Sorteringstype",
      "orderSelector": "Sorteringsrekkefølge",
      "queryFilter": "Fritekstsøk"
    },
    "HasPictures": "Kun objekter som har bilde",
    "LicenseTypesLabel": "Filtrer etter DM-lisenstyper",
    "MaxItemsLabel": "Antall elementer som skal vises",
    "NoImages": "Objektet har ingen bilder",
    "SearchConfig": "Innstilinger for søket",
    "ObjectTypesLabel": "Filtrer etter DM-objekttyper",
    "OrderBySelector": {
      "Label": "Sortering",
      "options": {
        "score": "Relevans",
        "relevance": "Relevans",
        "last_updated": "Sist oppdatert",
        "published_at": "Publiseringsdato"
      }
    },
    "OrderSelector": {
      "Label": "Sorteringsrekkefølge",
      "options": {
        "asc": "A-Å",
        "desc": "Å-A"
      }
    },
    "OwnerCodesLabel": "Liste med eierkoder",
    "OwnerCodeSelectOne": "Velg minst en eierkode",
    "PaginateMaxItemsLabel": "Maks antall",
    "PhysicalResources": "Fysiske ressurser (besøk på museet)",
    "PreviewFilterInfo": "Filter for sluttbruker er påslått, men vises kun i sluttportal",
    "QueryLabel": "Fritekstsøk av listevisningen",
    "RemoveObject": "Fjern det valgte objektet",
    "School": {
      "Grades": {
        "SelectGrade": "Velg trinn",
        "Options": {
          "kindergarten": "Barnehage",
          "grade_two": "1. - 2. trinn",
          "grade_four": "3. - 4. trinn",
          "grade_seven": "5. - 7. trinn",
          "grade_ten": "8. - 10. trinn",
          "vg_one": "Vg1",
          "vg_two": "Vg2",
          "vg_three": "Vg3"
        }
      },
      "SelectAtLeastOneOwner": "Velg minst ett museum",
      "Subject": {
        "SelectSubject": "Velg fag",
        "Options": {
          "SocialStudies": "Samfunnsfag",
          "Science": "Naturfag",
          "Norwegian": "Norsk",
          "DramaAndRhythmics": "Drama og rytmikk",
          "ReligionEthicsLifeStance": "KRLE",
          "ArtsAndCrafts": "Kunst og håndtverk",
          "FoodAndHealth": "Mat og helse",
          "Music": "Musikk"
        }
      }
    },
    "Show": "Vis",
    "ShowSchoolTypes": "Ressurstype (alt vises som standard)",
    "SelectMainPicture": "Velg hvilket bilde som skal vises",
    "SubjectsLabel": "Kommaseparert liste med emneord",
    "UseOwnerCodes": "Filtrer på DM-eiere",
    "VisitTheMuseums": "Besøk på museene",
    "VRItemsLabel": "Velg virtuelle opplevelser fra DM",
    "WideDisplayLabel": "Bruk en bredere stil"
  },
  "DMFilterSearch": {
    "AdditionalHiddenQuery": "Ekstra søkekriterier (kommer i tillegg til det som er valgt i filteret, og er skjult for sluttbruker)",
    "PlacesTitleLabel": "Steder",
    "PlacesDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "InputLabelPlaces": "Steder (kommaseparert)",
    "ExhibitionIdTitleLabel": "Utstillings UUID",
    "FolderIdTitleLabel": "Mappe UUID",
    "FreeTextSearch": "Fritekstsøk",
    "FreeTextSearchTitleLabel": "Søkeord",
    "FreeTextSearchDropDownMenuTitleLabel": "Tittel i søkeboksem  ",
    "IncludeFreeTextSearchLabel": "Inkludér fritekstsøk (søket gjøres innenfor de parametrene som er valgt over)",
    "InputLabelProducers": "Tilvirkere (kommaseparert)",
    "InputLabelMaterials": "Materiale (kommaseparert)",
    "InputLabelSubjectKeywords": "Emneord (kommaseparert)",
    "InputLabelTechnique": "Teknikk (kommaseparert)",
    "ItemsRestriction": "Absolutt begrensning",
    "KulturNavTitleLabel": "Kulturnavpost UUID",
    "LicenseTypesLabel": "DM-lisenstyper",
    "LicenseTypesDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "LicenseTypesTitleLabel": "Lisens",
    "LimitTitleLabel": "Antall elementer som skal vises",
    "Producers": "Tilvirkere",
    "ProducersDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "ProducersTitleLabel": "Tilvirker",
    "MaterialsDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "MaterialsTitleLabel": "Materialer",
    "MuseumsCollectionsTitleLabel": "Museer/samlinger",
    "NoAccessMessage": "Denne komponenten er satt opp av ansatte i KulturIT. Venligst ta kontakt ved ønske om endring.",
    "ObjectTypesTitleLabel": "Objekttyper",
    "ObjectTypesDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "ObjectTypesSelectInputLabel": "DM-objekttyper",
    "OwnerCodesDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "OwnerCodesLabel": "Liste med eierkoder",
    "ShowOnlyObjectsWithImage": "Vis kun objekter som har bilde",
    "ShowInSameTab": "Vis i samme fane (ved les mer)",
    "SubjectKeywordsFilter": "Emneordfiltrering",
    "SubjectKeywordsDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "SubjectKeywordsTitleLabel": "Emneord",
    "TechniqueDropDownMenuTitleLabel": "Tittel på nedtrekksmeny",
    "TechniqueTitleLabel": "Teknikk",
    "Time": "Tid",
    "TimeSliderTitle": "Tittel over slider",
    "TimeTitleLabel": "Tid",
    "TimeYearFrom": "År fra",
    "TimeYearTo": "År til",
    "UserFiltrationOnWebsite": "Vis filter"
  },
  "DMFinderHeader": {
    "FilterLabel": "Filtrer DM-søket",
    "HasLocation": "..koordinater",
    "HasPictures": "Har bilder",
    "HasVideo": "..video",
    "HasAudio": "..lyd",
    "ObjectType": "Objekttype",
    "OnlyOurOwnerCode": "Kun vår eierkode ({{ownerCode}})",
    "OnlyOurOwnerCodes": "..eierkoder",
    "Owner": "Eier"
  },
  "DMHeader": {
    "LicenseLabel": "Lisens:",
    "OwnerLabel": "Eier:"
  },
  "DMImagePicker": {
    "Cancel": "Avbryt",
    "Confirm_one": "Bruk {{count}} bilde",
    "Confirm_other": "Bruk {{count}} bilder",
    "ImageLabel": "Bilde {{number}}",
    "InfoTextMultiple": "Objektet har flere bilder. Velg ett eller flere.",
    "InfoTextSingle": "Objektet har flere bilder. Velg ett.",
    "NoImages": "Fant ingen bilder på objektet."
  },
  "DMViewTypeSelector": {
    "grid": "Rutenett",
    "list": "Liste",
    "simple": "Lenker med pil (ingen bilde)",
    "map": "Kart"
  },
  "DashboardView": {
    "BottomBanner": {
      "GetStarted": "Kom i gang med M24",
      "Heading": "Hvordan bruke Museum24",
      "KeywordIndex": "Stikkordregister",
      "Text": "Funksjoner, byggeklosser og eksempler",
      "TipsAndInspiration": "Tips og inspirasjon",
      "UserManual": "Gå til nettside"
    },
    "ContentWidget": {
      "EventsTitle": "Arrangement",
      "LastEdited": "Sist redigerte",
      "PagesTitle": "Innhold"
    },
    "CountResLabel": {
      "archived": "Arkivert",
      "audio": "Audio",
      "document": "Dokumenter",
      "draft": "Utkast",
      "image": "Bilder",
      "in_use": "I bruk",
      "published": "Publisert",
      "total": "Totalt",
      "video": "Video"
    },
    "EventsLabel": "Arrangementer",
    "FormsLabel": "Skjemaer",
    "FormsWidget": {
      "Title": "Skjemaer"
    },
    "MediaLabel": "Media",
    "MediaWidget": {
      "DAMSIntegrationEnabled": "DAMS-integrasjon aktivert",
      "Title": "Media"
    },
    "MessagesWidget": {
      "Title": "Meldinger fra museum24"
    },
    "PagesLabel": "Sider",
    "SettingsShortcutWidget": {
      "ChangeFooter": "Endre footer",
      "ChangeMenu": "Endre toppmenyen"
    },
    "SharingWidget": {
      "AccessGiven": "Delinger med andre siter",
      "AccessGranted": "Tilganger til andre siter",
      "NewRequests": "Du har nye forespørsler",
      "NoNewRequests": "Ingen nye forespørsler",
      "NoSharing": "Ingen delinger",
      "Title": "Tilganger/delinger"
    },
    "ReindexPagesWidget": {
      "Title": "Søkeindeks",
      "IncludeAllSites": "Inkluder alle siter",
      "Reindex": "Reindekser",
      "Reindexing": "Reindekserer...",
      "ReindexSuccess": "Søkeindeks oppdatert",
      "ReindexFailed": "Noe gikk galt under indeksering: {{error}}"
    },
    "WelcomeBannerWidget": {
      "DescriptionLabel": "Nettstedsbeskrivelse",
      "ImageLabel": "Nettsidens hovedbilde",
      "NoDescription": "– Ingen beskrivelse (legg til under forsidens metainnstillinger)",
      "NoFavicon": "– Ingen favicon (legg til favicon (og touchicon) under nettstedets innstillinger)",
      "NoImage": "– Ingen hovedbilde (legg til under forsidens metainnstillinger)",
      "NoDescriptionOrImage": "Beskrivelse og hovedbilde legges til under forsidens metainnstillinger."
    }
  },
  "DatelineBlock": {
    "Dateline": "Datolinje",
    "DatelineDescription": "Viser publiseringsdato, og klokkeslett hvis du vil. Du kan også vise når innholdet sist ble endret.",
    "LabelLastModifiedText": "Tekst foran sist endret",
    "LabelPublishedDate": "Publiseringsdato",
    "LabelShowLastModified": "Vis sist endret dato",
    "LabelShowTime": "Vis klokkeslett (for begge datoene)",
    "LabelText": "Tekst foran publiseringsdato",
    "LastModifiedDefaultText": "Sist endret",
    "Metadata": "Metainformasjon",
    "MetadataDescription": "Metadata brukes ikke lenger i versjon 2.0. For å legge til arrangementer, bruk arrangement-modulen.",
    "ShowLastModifiedHelp": "Vises bare når den er en annen dato enn publiseringsdatoen, eller et annet klokkeslett når klokkeslett vises."
  },
  "DeleteButton": {
    "AbortOption": "Nei",
    "AlternativeButtonLabel": "Fjern",
    "ConfirmDeleteQuestion": "Er du sikker?",
    "ConfirmOption": "Ja",
    "DefaultButtonLabel": "Slett"
  },
  "EditSelectedMedia": {
    "ConfirmUpdateSelection": "Er du sikker på at du vil oppdatere disse objektene?"
  },
  "EditorBreadcrumbItem": {
    "ChildrenLabel": "Undersider",
    "CreateChildPage": "Opprett underside",
    "EditLinkLabel": "Rediger {{title}}",
    "NoChildren": "Ingen undersider"
  },
  "EditorHeader": {
    "CreateEvent": "Opprett nytt arrangement",
    "CreatePage": {
      "ActionMenuLabel": "Opprett ny side",
      "Child": "Under denne siden",
      "Sibling": "På samme nivå"
    },
    "GoBack": "Gå tilbake",
    "ImportedPlaceHint": "Importert side. «Lagre og publiser» publiserer den og legger den på rot i sidetreet.",
    "LastUpdatedAt": "Sist oppdatert {{at}}",
    "PublishedAt": "Published at {{timestamp}}",
    "TemplateTooltip": "Dette er en mal, og er ikke tilgjengelig for visning i portal",
    "pageSettings": "Sideinnstillinger",
    "pageTemplateSettings": "Malinnstillinger"
  },
  "EditorPreviewContainer": {
    "FlipDeviceOrientation": "vend forhåndsvisning",
    "PreviewType": {
      "auto": "Auto",
      "desktop": "Stasjonær",
      "desktop_4k": "Stasjonær (4K)",
      "developer": "Utvikler",
      "fill": "Fyll",
      "mobile": "Mobil",
      "tablet": "Nettbrett"
    },
    "ShowInPortal": "Vis gjeldende version i portal"
  },
  "EditorSectionActionButton": {
    "Tooltip": "Handlinger"
  },
  "EkulturCallbackHandler": {
    "errors": {
      "missingCodeOrState": "Mangler nødvendig informasjon for å fullføre innloggingen",
      "swapForTokenFailed": "En feil oppstod ved innlogging"
    },
    "loggingIn": "Logger inn"
  },
  "EkulturLoginController": {
    "LoadingUser": "Sjekker innlogging...",
    "LoggedInAsUser": "Du er logget inn som: {{user}}",
    "NoAccess": "Du har ikke tilgang til denne appen. Ta kontakt med din eKultur-administrator for å få tilgang."
  },
  "EkulturLogoutHandler": {
    "logOutNow": "Logg ut nå",
    "loggingOut": "Logger ut...",
    "loggingOutInXSec_one": "Du logges ut om 1 sekund...",
    "loggingOutInXSec_other": "Du logges ut om {{count}} sekunder...",
    "logoutFailed": "En feil oppstod ved utlogging"
  },
  "EmployeeEditor": {
    "AddExternal": "Legg til ekstern lenke",
    "AddPage": "Legg til sidelenke",
    "ChangePage": "Bytt side",
    "ContactFieldsTitle": "Kontaktinformasjon",
    "Department": "Avdeling",
    "Description": "Beskrivelse / fritekst",
    "Email": "Epostaddresse",
    "FindImage": "Velg bilde",
    "Firstname": "Fornavn",
    "ImageFieldTitle": "Bilde og fokuspunkt",
    "InvalidUrl": "Ugylig URL-format",
    "Lastname": "Etternavn",
    "LinkName": "Lenkenavn",
    "LinksFieldTitle": "Lenker",
    "Page": "Side",
    "PageLinkTitle": "Link til side",
    "PageLinkAbout": "Denne lenken vil vises på ansattkortet og føre til en side på nettstedet. Siden må opprettes først, og kan inneholde mer informasjon om den ansatte, som for eksempel en forskningsprofil, prosjekter eller lignende. Linken vil også brukes i Byline-modul.",
    "PageLinkExternalAbout": "Denne/disse lenken(e) vil vises på ansattkortet og føre til angitt url. Øverste lenke vil også brukes i Byline-modul dersom ikke intern sidelenke ovenfor er angitt.",
    "Phone": "Telefonnummer",
    "Position": "Stilling",
    "RemoveImage": "Fjern bilde",
    "RemoveLink": "Fjern lenke",
    "RemovePage": "Fjern side",
    "RequiredFieldsMissing": "Påkrevede felter mangler: {{fields}}",
    "SaveFailed": "Noe gikk galt under lagring: {{error}}",
    "SaveSuccess": "Ansatt lagret",
    "SelectPage": "Velg side",
    "SwapImage": "Bytt bilde",
    "TextFieldsTitle": "Personinformasjon",
    "UrlExternal": "Ekstern url"
  },
  "EmployeesBlock": {
    "EnableSearch": "Vis søkeboks",
    "SearchTypeLabel": "Type søk",
    "SearchTypeOptions": {
      "local": "Lokal: Filtrering av ansatte i denne modulen",
      "page": "Side: Filtrering av ansatte i alle moduler på denne siden",
      "site": "Søkeside: Viser resultatet på en egen ansattsøkeside"
    },
    "EnableEmployeeSiteSearch": "Vis søkeboks for å søke etter ansatte via nettstedsøket",
    "SelectInfoToShow": "Velg hvilke felter som skal vises",
    "ShowDepartment": "Avdeling",
    "ShowDescription": "Beskrivelse",
    "ShowEmail": "Epost",
    "ShowLinks": "Lenker",
    "ShowPhone": "Telefonnummer",
    "ShowPosition": "Stilling",
    "ShowSite": "Museum"
  },
  "EmployeesView": {
    "AddEmployee": "Legg til ansatt",
    "HeaderCount": "Viser {{count}} av {{total}} ansatte",
    "Title": "Ansatte"
  },
  "EmployeesViewTypeSelector": {
    "grid": "Rutenett",
    "list": "Liste"
  },
  "EventData": {
    "AddTime": "Legg til nytt tidspunkt",
    "CategoryTitle": "Kategori: Arrangement",
    "Title": "Arrangementstittel ( = sidetittel)",
    "Description": "Arrangementsbeskrivelse ( = sidebeskrivelse)",
    "EndTime": "Slutt-tidspunkt",
    "FreeText": "Fritekst",
    "InvalidUrl": "Ugylid URL (https://...)",
    "Location": "Arrangementssted",
    "LocationText": "Uregistrert stedsinfo",
    "LocationTooltip": "Disse stedene legges til i dine sideinnstillinger",
    "ShowAsOneCardPerDateRow": "Vis som ett kort pr datolinje",
    "SkinLabel": "Velg farge for utlisting",
    "StartTime": "Starttidspunkt",
    "SubCategoryInfo": "Man trenger ikke sette underkategori hvis man ikke har behov for å spesifisere nærmere eller å filtrere på arrangementstyper.",
    "SubCategoryLabel": "Velg underkategorier for arrangement",
    "TicketText": "Egendefinert tekst til knapp",
    "TicketUrl": "URL-lenke til billett",
    "TimeInfoLabel": "Felles info (eks klokkeslett) for alle datoer",
    "UseEndDateLabel": "Inkluder sluttdato",
    "UseRangeLabel": "Definer tidsperiode",
    "UseTimeLabel": "Inkluder klokkeslett",
    "Weekdays": "Ukedager",
    "EnableStructuredMarkup": "Angi som et 'Google event'. (Kan da havne i Googles oversikt over arrangementer)"
  },
  "EventsBlock": {
    "CategoriesFilteringLabel": "Kategorier",
    "DateFilteringLabel": "Dato",
    "DisableExpandedDates": "Aldri vis et kort mer enn en gang",
    "DisplayOptions": {
      "Category": "Kategori",
      "Description": "Beskrivelse",
      "Location": "Sted",
      "Museum": "Museum (nettsted)"
    },
    "EventsLabel": "Arrangementer",
    "NoEventsSelected": "Ingen arrangementer er lagt til.",
    "FinderButton": "Velg arrangementer",
    "LocationFilteringLabel": "Steder",
    "MaxItemsLabel": "Maks. antall",
    "MuseumFilteringLabel": "Museer/Steder",
    "PreviewFilterInfo": "Arrangements-filter for sluttbruker er påslått, men vises kun i sluttportal",
    "Rules": "Innstillinger for uthenting",
    "ShowAllLinkPageButtonLabel": "Velg side",
    "ShowAllLinkPageTitle": "Link til \"Vis flere\" side (knapp under utlisting)",
    "ShowAllLinkType": {
      "button": "Knapp",
      "text": "Tekstlenke"
    },
    "ShowAllLinkTypeLabel": "Vis link som",
    "ShowForPeriodLabel": "Vis for periode",
    "ShowForPeriodType": {
      "1m": "1 mnd",
      "3m": "3 mnd",
      "6m": "6 mnd",
      "12m": "12 mnd",
      "previous": "Tidligere",
      "specify": "Spesifiser periode",
      "today": "Dagens"
    },
    "TargetGroupsFilteringLabel": "Målgrupper",
    "TodayFilteringLabel": "Dagens",
    "UseFilteringLabel": "Filtrer på",
    "UseLocationFiltering": "Steder",
    "UseMuseumFiltering": "Museer",
    "UserFilteringLabel": "Legg til filtrering/sortering for sluttbruker av utlistingen",
    "EnableSearchLabel": "Vis søkeboks",
    "OrderFilteringLabel": "Sorteringsrekkefølge"
  },
  "FavouriteButton": {
    "MarkAsFavourite": "Legg til i favoritter",
    "UnmarkAsFavourite": "Fjern fra favoritter"
  },
  "FilterMenu": {
    "FilterMenuTooltip": "Filtrer sider",
    "sections": {
      "MainCategories": "Hovedkategorier",
      "Statuses": "Statuser",
      "SubCategories": "Underkateorier"
    }
  },
  "Finder": {
    "CardTitle": "Kort",
    "EventsTitle": "Arrangementer",
    "Filter": {
      "CardType": "Korttype",
      "IncludeMediaTypes": "Mediatyper",
      "OnlyOwnerContent": "Kun lagt til av eier: {{ownerName}}",
      "OnlyUserContent": "Kun lagt til av meg",
      "ShowContentFrom": "Vis innhold fra..."
    },
    "FinderSource": {
      "digitalt_museum": "Digitalt Museum",
      "e_kultur": "eKultur",
      "favourites": "Favoritter",
      "museum_24": "Museum 24"
    },
    "MediaTitle": "Mediagalleri",
    "MediaTitleDams": "DAMS Mediagalleri",
    "PageTitle": "Sider",
    "Search": "Søk etter innhold...",
    "SelectMuseum": "Velg museum",
    "SelectDamsGallery": "Velg DAMS-galleri",
    "TemplatesTitle": "Maler",
    "UseSelected_interval": "(0)[Ingen valgte elementer];",
    "UseSelected_one": "Velg element",
    "UseSelected_other": "Velg {{count}} elementer"
  },
  "FinderButton": {
    "card": "Legg til kort",
    "dams": "Velg fra DAMS",
    "digitaltMuseum": "Velg fra DigitaltMuseum",
    "employee": "Legg til ansatt(e)",
    "form": "Legg til et skjema",
    "icon": "Legg til et ikon",
    "kp": "Legg til objekter fra KulturPunkt",
    "kp_owner": "Legg til et Kulturio-museum",
    "m24": "Velg bilder/filer fra mediagalleriet",
    "m24_images_video": "Velg bilde(r) eller video(er) fra mediagalleriet",
    "m24_images": "Velg fra mediagalleriet",
    "owner": "Legg til et museum"
  },
  "FolderView": {
    "ConfirmDeleteFolderDialogHtml": "<p>Er du sikker på at du vil slette mappen <strong>{{folderName}}</strong>?</p><p>Alle undermapper vil bli slettet, og alle sider blir flyttet ut av mapper.</p>",
    "DeleteActionButton": "Slett",
    "MoveActionButton": "Flytt til...",
    "MoveDialogTitle": "Flytt til mappe",
    "cancel": "Avbryt",
    "confirmMoveButton": "Flytt",
    "createNewFolder": "Opprett mappe",
    "createdAtDate": "Opprettet {{date}}",
    "editName": "Rediger navn",
    "folderItemCount": "{{ count }} arrangementer",
    "newFolderDefaultName": "Ny mappe",
    "rootFolderName": "Arrangementer",
    "newFolderNameLabel": "Navn på mappe",
    "createAndClose": "Opprett",
    "createAndNew": "Legg til og ny",
    "closeDialog": "Avbryt"
  },
  "FormEditor": {
    "AddBlockType": "+ {{blockType}}",
    "AddSection": "+ Seksjon/steg",
    "Address": {
      "AddressLabel": "Adresse",
      "CountryCodeLabel": "Landkode",
      "PostalCodeLabel": "Postnummer",
      "PostalPlaceLabel": "Poststed",
      "StateLabel": "Stat/provins"
    },
    "AttachmentsSizeLimit": "Størrelsesbegrensning for fil-opplasting",
    "BlockType": {
      "button": "Knapp",
      "checkbox": "Ja/Nei",
      "content": "Tekst",
      "input": "Inputfelt",
      "options": "Alternativer",
      "user": "Kontaktinformasjon"
    },
    "InternalLabel": "Intern tittel",
    "ButtonLabel": "Knappetekst",
    "EmailReceiver": "E-postmottaker",
    "FieldSettings": "Innstillinger for felt",
    "FormInvalidLabel": "Tekst for ugyldig skjema",
    "InUseByPages": "I bruk på følgende sider",
    "InputLabel": "Ledetekst ved inputfelt",
    "NewForm": "Nytt skjema",
    "Preview": {
      "DefaultFileButtonLabel": "Last opp",
      "DefaultFileLabel": "Filopplasting",
      "button": {
        "default": "Send inn",
        "next": "Neste",
        "prev": "Forrige",
        "reset": "Nullstill"
      }
    },
    "SectionInputs": "Seksjon/steg med inputfelter",
    "SectionReceipt": "Kvittering",
    "SendEmailOnSubmissions": "Send epost ved svar",
    "button": {
      "defaultBlockLabel": "Send inn",
      "nextBlockLabel": "Neste",
      "prevBlockLabel": "Forrige",
      "prev_nextBlockLabel": "Forrige/Neste",
      "resetBlockLabel": "Nullstill"
    },
    "input": {
      "FirstNameLabel": "Fornavn",
      "LastNameLabel": "Etternavn",
      "ShowImagePreview": "Vis forhåndsvisning",
      "addressBlockLabel": "Adresse",
      "dateBlockLabel": "Dato",
      "emailBlockLabel": "E-post",
      "fileBlockLabel": "Filopplasting",
      "nameBlockLabel": "Navn",
      "textBlockLabel": "Tekst (enkeltlinje)",
      "textareaBlockLabel": "Tekstfelt"
    },
    "options": {
      "AddAlternative": "Legg til alternativ",
      "Horizontal": "Horisonale valg",
      "OptionN": "Alternativ {{n}}",
      "PreSelected": "Forhåndsvalgt",
      "checkboxBlockLabel": "Flere valg",
      "radioBlockLabel": "Ett valg"
    },
    "user": {
      "Address2Enabled": "Inkluder adresselinje 2 (nabolag, bygning el.)",
      "CompleteAddressEnabled": "Inkluder fritekstfelt (tilleggsinfo, adresse el.)",
      "ConfirmEmail": "Bruker må bekrefte epost (2 felt)",
      "CountryCodeEnabled": "Inkluder landkode",
      "Description": "Feltene \"Fornavn\", \"Etternavn\" og \"Epost\" er alltid påkrevet.",
      "EmailConfirmLabel": "Bekreft e-post",
      "EmailLabel": "E-post",
      "FirstnameLabel": "Fornavn",
      "LastnameLabel": "Etternavn",
      "PhoneLabel": "Ledetekst telefon",
      "StateEnabled": "Inkluder stat/provins",
      "completeBlockLabel": "Komplett",
      "minimumBlockLabel": "Minimal",
      "simpleBlockLabel": "Enkel"
    }
  },
  "FormView": {
    "BackToOverview": "< Tilbake til skjemaoversikt",
    "CreateNewForm": "Opprett nytt skjema",
    "DeleteAll": "Slett alle",
    "DeleteData": "Slett data",
    "DeleteIndividual": "Slett enkelte",
    "EditForm": "Rediger skjema",
    "ExportData": "Eksporter data",
    "FormData": "Skjemadata",
    "FormDeletedFailed": "Noe gikk galt under sletting: {{error}}",
    "FormDeletedSuccess": "Skjema slettet",
    "NoItems": "Fant ingen skjema",
    "NumberOfPagesInUse": "I bruk på antall sider: {{count}}",
    "OlderThanX": "Eldre enn {{days}} dager",
    "ShowAnswers": "Vis svar ({{count}})",
    "Title": "Skjema"
  },
  "GoogleMapsAutoComplete": {
    "AddLocationLabel": "Søk etter sted",
    "NoOptionsText": "Ingen treff"
  },
  "GridViewDMVariant": {
    "License": "Lisens",
    "Owner": "Eier",
    "Pictures": "Bilder"
  },
  "ImageWithFocusPointSelector": {
    "SelectFocusPoint": "Velg fokuspunkt for {{imageName}}",
    "SelectFocusPointDescription": "Klikk på bildet for å velge fokuspunkt"
  },
  "KPBlock": {
    "AdditionalPointsTooltip": "Disse KulturPunktene vises i tillegg til eventuelle underpunkter eller utvalg fra en presentasjon ovenfor",
    "BigViewLabel": "Stor visning",
    "displayDescription": "Vis beskrivelse",
    "DisplayOptionsModuleLabel": "Visningsinnstillinger for denne modulen",
    "DisplayOptionsItemLabel": "Visningsinnstillinger for elementene",
    "IntegratedView": "Integrert visning (ved les mer)",
    "IntegratedViewLabel": "Åpne innhold med integrert visning i stedet for i KulturPunkt.org",
    "JustBanner": "Bare vis banner",
    "KPArticlesLabel": "Velg KulturPunkter/rebuser",
    "KPOwnersLabel": "Velg museer fra Kulturio",
    "KPPresentationLabel": "Velg en KulturPunkt-presentasjon",
    "KPPresentationsLabel": "Velg KulturPunkt-presentasjoner/rebuser",
    "ListArticles": "Vis KulturPunkter",
    "ListArticlesLabel": "List underpunkter",
    "ListPresLabel": "List underpresentasjoner",
    "ListPresentations": "Vis presentasjoner",
    "MapSettings": "Kartinnstillinger",
    "NoBackground": "Ingen bakgrunnsfarge (gjennomsiktig)",
    "PickSelectionLabel": "Velg et utvalg",
    "PickSubArticlesLabel": "Velg underpunkter",
    "PresChildrenLabel": "Plukk KulturPunkter fra denne presentasjonen",
    "whiteBackground": "Hvit bakgrunn",
    "disableEkulturMapPin": "Bruk standard kart-pin"
  },
  "KPFinderHeader": {
    "FilterByOwner": "Bare vis objekter som tilhører din egen Kulturio-eier",
    "KPOwnerHeader": "Museer",
    "KPSchemaType": {
      "2": "Artikler",
      "12": "Presentasjoner",
      "13": "Kiosk-visninger",
      "14": "Kiosk-enheter"
    }
  },
  "LicenseSelector": {
    "SelectLicense": "Lisens"
  },
  "LinkListBlock": {
    "AdvancedSettings": {
      "GroupBy": {
        "Label": "Gruppering av lenkene",
        "alpha": "Alfabetisk",
        "false": "Nei"
      },
      "OrderBy": {
        "Label": "Automatisk sortering av lenkene",
        "_date": "Dato (publisert)",
        "_title": "Alfabetisk (tittel)",
        "false": "Manuell"
      },
      "Title": "Avanserte innstillinger",
      "reverseOrder": "Omvendt rekkefølge",
      "showDate": "Vis publiseringsdatoer"
    }
  },
  "LinkListItem": {
    "Anchor": "Anker (#ID)",
    "ChangeFile": "Bytt fil",
    "File": "Fil",
    "OpeningRule": "Åpneregel",
    "Target": {
      "_blank": "Ny fane",
      "_self": "Samme fane",
      "auto": "Auto",
      "m24ref": "Ny felles fane"
    },
    "Url": "URL"
  },
  "Links": {
    "LinkButtons": {
      "document": "Link til dokument",
      "event": "Link til arrangement",
      "link": "Link (intern/ekstern)",
      "page": "Link til side"
    },
    "LinkExternal": "Link eksternt",
    "LinkInternal": "Link internt",
    "LinkListBelowBodytext": "Lenkeliste under brødtekst",
    "ListChildren": "List ut alle sider som ligger rett under denne",
    "Options": {
      "button": "Knapper",
      "list": "Tekstlenker",
      "arrow_list": "Lenker med pil/bakgrunn",
      "module": "Hele modulen klikkbar (bruker lenke nr 1)"
    },
    "SelectLinkStyle": "Vis lenker som",
    "TitleOverLinkList": "Tittel over lenkeliste"
  },
  "ListCardsForPage": {
    "Title": "Kort som peker til denne siden."
  },
  "LocationSelector": {
    "InputLabel": "Sted"
  },
  "M24Content": {
    "CaptionHint": "Skriv egen bildetekst her, hvis standard bildetekst ikke passer",
    "EditGlobalMediaData": "Rediger globale mediedata i mediegalleriet",
    "MissingAltTextWarning": "Alternativ beskrivelse mangler",
    "ForcePortraitMode": "Tving videovising til portrettformat",
    "HideZoomButton": "Skjul zoom-knapp"
  },
  "M24PageFinder": {
    "M24PageFinderHeader": {
      "ShowDraft": "Vis utkast"
    }
  },
  "MainMenu": {
    "analytics": "Analyse",
    "cards": "Kort",
    "content": "Innhold / Sidetre",
    "dashboard": "Dashboard",
    "employees": "Ansatte",
    "events": "Arrangementer",
    "forms": "Skjemaer",
    "media": "Mediagalleri",
    "settings": {
      "cardCategories": "Kortkategorier",
      "categories": "Kategorier",
      "keywords": "Stikkord",
      "language": {
        "create": "Opprett nytt språk",
        "title": "Språkinnstillinger"
      },
      "locations": "Steder",
      "pageTemplates": "Maler",
      "sharing": "Tilganger og delinger",
      "site": "Innstillinger",
      "users": "Brukere",
      "webpage": "Generelt",
      "owner": "Eierinformasjon/struktur"
    },
    "styles": "Farger og stilsett",
    "stylesDescription": "Du kan trykke på nettstedsiconet i header eller lenken nedenfor for å se en mer detaljert oversikt over farger og stilsett ute på nettstedet."
  },
  "Manual": {
    "article__card": "https://manual.museum24.no/faktakort",
    "article__openinghours": "https://manual.museum24.no/apningstider",
    "article__person": "https://manual.museum24.no/person",
    "article__sharing": "https://manual.museum24.no/deleknapper",
    "calendar": "https://manual.museum24.no/kalender",
    "calendar__navigator": "https://manual.museum24.no/kalender",
    "digitaltMuseum": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "kulturpunkt": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "search": "https://manual.museum24.no/sokeresultat"
  },
  "MapV2Block": {
    "AddLocation": "Opprett punkt på kart",
    "InfoBoxHtml": "<p><em>Dette er en ny og forenklet kartmodul. Visning av KulturPunkt og DigitaltMuseum i kart gjøres nå enkelt i egne moduler for KP/DM.<em></p><p><em><a href=\"https://manual.museum24.no/kart\">Mer om disse modulene her</a></em></p>",
    "InfoBoxZoom": "Kartvisningen zoomer inn automatisk basert på punktene, slik at kartet alltid vil vise alle punktene på kartet. Er det flere som er plassert nær hverandre, vil disse bli vist gruppert (cluster), som vises som enkeltpunkter når brukeren zoomer inn på kartet.",
    "MapDesign": {
      "black_white": "Sort/hvitt",
      "label": "Kartstil",
      "normal": "Normal"
    },
    "MapType": {
      "ROADMAP": "Veikart",
      "SATELLITE": "Satelitt",
      "label": "Type"
    },
    "addSiteLocationHelpText": "Registrerte steder fra innstillinger som skal vises på kartet.",
    "addSiteLocationLabel": "Velg registrerte steder",
    "enableMapTypeHelperText": "La brukeren velge karttype",
    "enableMapTypeLabel": "Aktiver karttype-velger",
    "enableStreetViewHelperText": "La brukeren aktivere Google Street View i kartet",
    "enableStreetViewLabel": "Aktiver Street View",
    "enableWayfinderLabel": "Aktiver veiviser",
    "enableWayfinderLabelHelperText": "Vis en knapp for å la brukeren starte veiviser til målet"
  },
  "MapV2MarkerFormField": {
    "missingTitle": "Sted uten navn"
  },
  "MediaBlock": {
    "AudioVideoContentMessage": "Det finnes nå egne moduler for VIDEO og LYD. Bruk disse for mer typetilpassede visnings og redigeringsmuligheter.",
    "CompareTwoImages": "De to neste bildene sammenlignes",
    "ColumnSizeLabel": "Antall kolonner (på større skjermer)",
    "ColumnSizeHelperText": "Du kan velge bredde på modulen øverst. Velg en bredde som passer med antall kolonner for best resultat.",
    "EnableZoomButton": "Gjør bildene klikkbare (åpnes større)",
    "ExternalContentMessage": "Det finnes nå egne moduler for VIDEO og LYD (intern og ekstern). Flytt gjerne dette innholdet til en av disse modulene, for bedre visning og mer relevante redigeringsmuligheter.",
    "DisableCaptions": "Skjul bildetekst på alle bilder (vises i fullvisning)",
    "Layout": {
      "Auto": "Auto (bilde fyller rammen)",
      "Frame": "Vis hele bildet (ramme fylles med modulens bakgrunnsfarge/skin)"
    },
    "MissingImageToCompare": "Mangler bilde å sammenligne. Velg fil under.",
    "ShowCaptions": "Vis bildetekster",
    "ShowCaptionsInFullScreen": "Vis bildetekster i fullvisning",
    "ShowCaptionsUnderThumbnails": "Vis bildetekster under thumbnails",
    "SizeLabel": {
      "default": "Small",
      "large": "Large",
      "medium": "Medium"
    }
  },
  "MediaEditor": {
    "AltText": "Alternativ tekst",
    "Caption": "Beskrivelse",
    "CreditName": "Krediteringsnavn",
    "CreditType": "Krediteringstype",
    "DAMS": "DAMS informasjon",
    "DAMSInfo": "Dette medieelementet er importert fra DAMS. Her er noe av informasjonen som vi fikk med oss derfra.",
    "DAMSProducers": "Produsent/Fotograf",
    "DAMSSubjects": "Emner",
    "DAMSPlaces": "Steder",
    "DAMSLicenses": "Lisens",
    "DownloadFile": "Last ned fil",
    "HideEditLocales": "Skjul tekstfelt for andre språk",
    "ImageCaption": "Bildetekst (undertekst)",
    "InUseLinksLabel": "Denne media-ressursen er i bruk de følgende stedene:",
    "LicenseAndCredits": "Lisens og kreditering",
    "LicenseType": "Lisenstype",
    "OpenInNewTab": "Åpne fil i ny fane",
    "SaveSuccess": "Media lagret",
    "SelectLicense": "Velg lisens",
    "ShowEditLocales": "Vis tekstfelt for andre språk enn hovedspråk",
    "TagsInfo": "Legg på stikkord for lettere gjenfinning/søk etter mediafiler",
    "TagsLabel": "Velg eller opprett nytt stikkord...",
    "TextFieldsTitle": "Tittel, beskrivelse og alternativ tekst for hovedspråk",
    "Title": "Tittel",
    "pickPoster": "Velg plakat/cover",
    "removePoster": "Fjern plakat/cover"
  },
  "MediaList": {
    "NoItems": "Ingen elementer"
  },
  "MediaView": {
    "AltTextMissingOnMedia": "{{count}} mediaobjekter mangler alt-tekst",
    "ConfirmBatchDelete": "Er du sikker på at du vil slette alle valgte objekter?",
    "ConfirmBatchRemove": "Er du sikker på at du vil fjerne alle valgte objekter?",
    "ConfirmDelete": "Er du sikker på at du vil slette objektet?",
    "ConfirmRemove": "Er du sikker på at du vil fjerne objektet?",
    "Created_at": "Opplastet",
    "Created_by": "Opplastet av",
    "CreditTypes": {
      "artist": "Artist",
      "author": "Forfatter",
      "owner": "Eier",
      "photographer": "Fotograf",
      "voice": "Stemme",
      "illustrator": "Illustratør",
      "movie": "Film"
    },
    "Delete_selected": "Slett valgte",
    "Remove_selected": "Fjern valgte",
    "EditSelectedMedia": "Rediger valgte mediaobjekter",
    "EditState": {
      "group_remove": "Fjern flere",
      "group_delete": "Slett flere",
      "group_update": "Rediger flere",
      "single": "Velg ett"
    },
    "Filename": "Filnavn",
    "Filetype": "Filtype",
    "FilterMissingAlt": "Bare media som mangler alt. tekst",
    "ShowDamsObjects": "Vis DAMS objekter",
    "InUse": "I bruk på {{pages}} sider, {{cards}} kort, {{persons}} personer og {{others}} andre steder.",
    "License": "Lisens",
    "ListView": {
      "Action": "Handling",
      "Details": "Detaljer",
      "Media": "Media"
    },
    "MediaId": "M24 media-ID",
    "MediaUpdated": "{{nr}} mediaobjekter ble oppdatert",
    "MediaUpload": {
      "Header": "Last opp mediafiler",
      "Upload": "Last opp",
      "HelpText": "Klikk for å velge mediafiler, eller dra filer hit",
      "UploadsFailed": "{{failed}} av {{total}} ble ikke lastet opp",
      "FilesUploaded": "{{files}} filer ble lastet opp",
      "OneUploaded": "Filen ble lastet opp",
      "ConfirmLeaveEditStage": "Er du ferdig med å redigere de opplastede filene?",
      "InvalidFilesRemoved": "{{count}} ugyldige eller dupliserte filer ble fjernet fra utvalget",
      "UploadFiles": "Last opp filer",
      "AddMetadata": "Legg til metadata",
      "AddToGallery": "Legg til i galleri"
    },
    "MissingAlt": "Alternativ tekst mangler",
    "NotInUse": "Ikke i bruk noen steder",
    "NrSelected": "{{nr}} valgt",
    "Tags": "Stikkord",
    "Title": "Media",
    "Update_selected": "Oppdater valgte",
    "Updated_at": "Endret",
    "UpdatesFailed": "{{failed}} av {{total}} objekter ble ikke oppdatert",
    "UploadMedia": "Last opp fil"
  },
  "MediaViewTypeSelector": {
    "MediaViewTypeVariant": {
      "compareTwoImages": "Sammenlign",
      "grid": "Bildegalleri, kvadratiske bilder",
      "grid__packery": "Bildegalleri Auto",
      "list": "Liste / Kolonner",
      "slideshow": "Slideshow"
    }
  },
  "Migration": {
    "Cards": {
      "SectionHelpText": "<p>Kort opprettes og redigeres nå KUN under \"Kort\", på samme måte som \"Ansatte\". Kategorisystemet fra gammel løsning er fortsatt knyttet til kort, mens det nye integrerte kategorisystemet brukes til \"Sideutlisting\" og \"Arrangementer\"</p><p><a href=\"#todo\">Mer om disse endringene her.</a></p>"
    },
    "Persons": {
      "CardBlock": "<p><strong>Museum24 1.0 vs 2.0 info verørende personer vs ansatte.</strong></p><p>Denne modulen viser \"personkort\", et konsept som erstattes av \"Ansatte\" i Museum24 2.0.</p><p>Ansatte kan i stedet listes ut med nye Ansatte-moduler, som du finner i liste-seksjonen. Når slike moduler er satt opp kan du fjerne denne kortmodulen. PS! Alle eksterende personer (\"personkort\") er automatisk blitt migrert til ansatte.</p>",
      "PersonBlock": "<p>Personer (ansatte) opprettes og forvaltes under Ansatt-galleriet i Museum24 2.0. PS! Alle eksterende personer (\"personkort\") er automatisk blitt migrert til ansatte.</p>"
    },
    "article__card": "<p><strong>Kort/Faktaboks kan erstattes med tekstmodul (vist som en boks), og/eller ved å legge inn info på sidens arrangementsinnstillinger</strong></p>",
    "article__openinghours": "<p><strong>Åpningstider-modulen kan erstattes med en tekstmodul vist som en boks.</strong></p>",
    "article__person": "<p><strong>Person-moduler vist direkte på en side eller via kortmoduler erstattes med ansatte og ansatte-moduler, dersom personer representerer ansatte</strong></p>",
    "article__sharing": "<p>Foreløpig ingen alternativ løsning tilgjengelig.</p>",
    "calendar": "<p><strong>Kalender-modulen kan erstattes av arrangements-moduler, som du finner i den nye liste-seksjonen</strong></p>",
    "calendar__navigator": "<p><strong>Kalender-navigator erstattes av arrangements-moduler, som du finner i liste-seksjonen</strong></p>",
    "digitaltMuseum": "<p><strong>DigitaltMuseum-modulen kan ersattes av nye DigitaltMuseum-moduler, som du finner i den nye liste-seksjonen.</strong></p>",
    "intro": "<p>** Modulen videreføres ikke i Museum24 2.0. Les om hva du kan gjøre for å erstatte den nedenfor. <br/>PS! Modulen vil vises på nettstedet, men ikke forhåndsvisningen, frem til dere sletter den fra siden.<p>",
    "kulturpunkt": "<p><strong>Kulturpunkt-modulen kan erstattes av nye KulturPunkt-moduler, som du finner i den nye liste-seksjonen.</strong></p>",
    "preview": "Ingen forhåndsvisning av denne modulen i Museum24 2.0",
    "readMore": "Les mer på: ",
    "search": "<p><strong>Søket blir ersattet av et nytt standard-opplegg</strong></p>"
  },
  "PageBlockArticleTitleBlockTextAlignSetting": {
    "Tooltip": "Text alignment",
    "options": {
      "auto": "Auto",
      "center": "Midtstilt",
      "left": "Venstre"
    }
  },
  "PageBlockAttachmentViewSetting": {
    "ViewTypeVariant": {
      "grid": "Rutenett",
      "list": "Liste"
    },
    "ViewTypeWidth": {
      "none": "Normal",
      "normal": "Normal",
      "wide": "Bred"
    }
  },
  "PageBlockBannerLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "box": "Tekstboks",
      "default": "Variabel høyde",
      "img": "Tekst på bilde",
      "img-bottom": "Bilde under",
      "img-left": "Bilde til venstre",
      "img-right": "Bilde til høyre",
      "img-top": "Bilde over",
      "img-top no-margin": "Bilde over, uten marger",
      "special": "Spesial",
      "textlines": "Tekstlinjer"
    }
  },
  "PageBlockBannerSizeSetting": {
    "Tooltip": "Størrelse",
    "options": {
      "l": "l",
      "l-m": "l-m",
      "m": "m",
      "m-s": "m-s",
      "s": "s",
      "s-m": "s-m",
      "xl": "xl"
    }
  },
  "PageBlockCollapsibleStateSetting": {
    "Tooltip": "Åpen/lukket",
    "options": {
      "collapsed": "Lukket",
      "expanded": "Åpen",
      "semi": "Delvis"
    }
  },
  "PageBlockLayoutSetting": {
    "Tooltip": "Visningstype",
    "options": {
      "auto": "Auto",
      "full": "Fyll bredde (nettsted)",
      "fullWidth": "Full bredde",
      "img-left": "Bilde til venstre",
      "img-right": "Bilde til høyre",
      "normal": "Normal",
      "wide": "Bred"
    }
  },
  "PageBlockLinkListViewSetting": {
    "Tooltip": "Visningstype",
    "options": {
      "list": "Enkel liste",
      "teasers": "Utdragsliste"
    }
  },
  "PageBlockModuleLayoutSetting": {
    "Tooltip": "Modullayout",
    "options": {
      "auto": "Bilde over",
      "img-landscape": "Landskap",
      "img-portrait": "Portrett",
      "left": "Venstre",
      "list": "Liste",
      "right": "Høyre",
      "img": "Bakgrunnsbilde"
    }
  },
  "PageBlockModuleTypeSetting": {
    "Tooltip": "Modultype",
    "options": {
      "bodytext": "Tekst",
      "inline": "Tekst",
      "module": "Tekstboks med bakgrunn"
    }
  },
  "PageBlockPageListLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "img": "Tekst på bilde",
      "img-top": "Bilde over",
      "img-top no-margin": "Bilde over, uten marger",
      "list": "Liste",
      "textlines": "Tekstlinjer (SuperAdm)"
    }
  },
  "PageBlockPositionSetting": {
    "Tooltip": "Posisjon",
    "options": {
      "full": "Full",
      "left": "Venstre",
      "normal": "Standard",
      "right": "Høyre",
      "wide": "Bred"
    }
  },
  "PageBlockTextPositionSetting": {
    "Tooltip": "Tekstjustering",
    "options": {
      "left": "Venstre",
      "normal": "Midtstilt",
      "right": "Høyre",
      "wide": "Bred"
    }
  },
  "PageBlockTextSizeSetting": {
    "Tooltip": "Tekststørrelse",
    "options": {
      "h-large": "Large",
      "h-medium": "Medium",
      "h-normal": "Normal",
      "h-xl": "XL"
    }
  },
  "PageEditor": {
    "DeleteDraftConfirm": "Er du sikker på at du vil slette utkastet?",
    "missingEventDateWarning": "Tidspunkt mangler",
    "newTemplateConfirmDialog": {
      "cancel": "Nei, fortsett å rediger denne siden",
      "navigateToTemplate": "Ja, se mal",
      "prompt": "Ny mal oppretter under Innstillinger > Maler. Vil du gå til malen nå?"
    }
  },
  "PageFolderAutocomplete": {
    "NoFolder": "Ingen mappe"
  },
  "PageListAutoBlock": {
    "Adjustments": "Andre innstillinger",
    "Categories": {
      "MainLabel": "Hovedkategori",
      "SubLabel": "Underkategorier"
    },
    "ChoosePage": "Velg side",
    "ChoosePageCurrentPage": "Velg denne siden",
    "Highlight": "Fremhev alle",
    "MaxSearchResultsSelector": {
      "Label": "Maks antall",
      "options": {
        "undefined": "Auto"
      }
    },
    "Textlines": "Tekstlinjer",
    "OrderBySelector": {
      "Label": "Sortering",
      "options": {
        "published_at": "Publiseringsdato",
        "title": "Alfabetisk",
        "undefined": "Auto"
      }
    },
    "OrderSelector": {
      "Label": "Sorteringsrekkefølge",
      "options": {
        "asc": "Stigende",
        "desc": "Synkende",
        "undefined": "Auto"
      }
    },
    "PageTreeButtonLabel": "Velg fra sidetre",
    "RemoveLeftPadding": "Fjern tekstmarg (hvis bilde topp og tekst under)",
    "SearchLevel": {
      "children": "Alle sider under valgt side",
      "siblings": "Alle sider på samme nivå"
    },
    "SearchPath": {
      "Label": "Valgt side",
      "NoSelection": "Ikke valgt"
    },
    "SelectCategoryButtonLabel": "Velg kategori",
    "SitesLabel": "Museer",
    "ThreeCols": "Tre kolonner"
  },
  "PageListManualBlock": {
    "DisplayInputs": {
      "Label": "Velg hvilke felter skal vises på kortene?",
      "displayCategory": "Sidekategori",
      "displayDescription": "Sidebeskrivelse",
      "displayInsertTitle": "Stikktittel",
      "displayLocation": "Sted",
      "displayMuseum": "Museum (nettsted)",
      "displayPosition": "Angitt sted",
      "displayPublishedDate": "Publiseringsdato"
    },
    "FilteringOptions": "Filteringsalternativer for sluttbruker",
    "PageListManualBlockItemContent": {
      "DescriptionHelperText": "Legg til kort introtekst hvis ønskelig",
      "Highlight": "Fremhev denne",
      "ImageTopPosition": "Toppjuster bildet",
      "TitleHelperText": "Skriv egen overskrift her, hvis standard overskrift ikke passer"
    },
    "PagesLabel": "Sider som det skal lenkes til",
    "NoPagesSelected": "Ingen sider er lagt til denne modulen enda",
    "SelectPages": "Plukk sider"
  },
  "EventListViewTypeSelector": {
    "grid": "Rutenett",
    "list": "Liste"
  },
  "EventListLayouts": {
    "img-top": "Bilde over",
    "img-top no-margin": "Bilde over, uten marger/skygger"
  },
  "PageListViewTypeSelector": {
    "grid": "Rutenett (bannere)'",
    "list": "Liste (kort)",
    "simple": "Lenker med pil/bakgrunn"
  },
  "PageMetadata": {
    "EventNotAllowed": {
      "children": "En side med undersider kan ikke være et arrangement.",
      "frontpage": "Forsiden kan ikke være et arrangement."
    },
    "MainCategoryLabel": "Velg hovedkatergori",
    "SubCategoriesLabel": "Velg underkategorier",
    "description": "Sidebeskrivelse",
    "mainImageDescription": "Hovedbildet vises når denne siden opptrer i side- og arrangements-lister. Du kan sette fokuspunkt i bildet.",
    "mainImageMissingInfotext": "Eksterne tjenester slik som Facebook vil også vise hovedbildet hvis siden deles der. Uten hovedbilde, vil slike tjenester plukke et vilkårlig bilde fra siden.",
    "metaTitle": "Egendefinert nettleser-tittel. Angis kun hvis annet enn standardformatet; 'Sidetittel - Nettstedsnavn'",
    "metadescription": "SEO: Beskrivelse. Angis kun hvis den skal være annet enn sidebeskrivelse",
    "pageMainImage": "Sidens hovedbilde",
    "selectImageHeading": "Velg bilde fra:",
    "syncPageDescription": "Sett sidebeskrivelse til det samme som ingress"
  },
  "PageSettings": {
    "CancelEditPath": "Tilbakestill til: \"{{old}}\"",
    "Category": "Kategori",
    "CategoryNew": "Kategori (ny)",
    "CategoryOld": "Kategori (gammel)",
    "Close": "Lukk sideinnstillinger",
    "CloseTemplateSettings": "Lukk malinnstillinger",
    "ConfirmApplyTemplate": "Å hente inn en mal vil overskrive gjeldende innhold. Er du sikker på at du vil fortsette?",
    "EnableEditPath": "Lås opp sti",
    "FormLabels": {
      "IsLongread": "Longread-artikkel med egen/enkel header",
      "Slug": "Sti",
      "Title": "Sidetittel",
      "accessCode": "Tilgangskode",
      "pageAlreadyHasAccessCode": "Denne siden har allerede en tilgangskode. Å legge inn en ny kode vil erstatte den gamle.",
      "isProtected": "Bruker må angi kode for å se siden",
      "protectedButton": "Beskyttet side: Tekst på innloggingsknapp",
      "protectedError": "Beskyttet side: Feilmelding",
      "protectedIntro": "Beskyttet side: Kort intro",
      "protectedLabel": "Beskyttet side: Tekst i kodeinputfelt",
      "protectedTitle": "Beskyttet side: Tittel"
    },
    "LockedByParentInfo": "Denne siden er låst fordi en overordnet side er låst. Du kan legge til en egen tilgangskode for denne siden nedenfor.",
    "Locations": "Steder",
    "LongreadLogoLink": "Logolink",
    "LongreadLogoText": "Logo (tekst)",
    "PublishDateTip": "TIPS! Publiseringsdato kan også brukes til tidsinnstilt publisering.",
    "PublishDateTipLearnMore": "Lær mer om tidsinnstilt publisering her.",
    "PublishDateTipDescription": "Publiseringsdato styrer når siden regnes som publisert. Dersom siden publiseres og denne datoen er i fremtiden, vil siden ikke være synlig for publikum før den datoen inntreffer. Dette gjør det mulig å sette opp tidsinnstilt publisering, hvor du kan forberede en side og sette den til å bli publisert automatisk på et senere tidspunkt.",
    "RevisionsTable": {
      "CreatedBy": "Lagret av: Navn (Bruker-ID)",
      "CreatedByName": "Navn",
      "Current": "gjeldende",
      "EditedVersion": "Versjon {{number}} «{{title}}» ({{status}})",
      "InfoText": "Her er de 10 forrige lagringene av versjonen av siden du jobber på nå.",
      "InfoTextWithCurrent": "Her er de 10 siste lagringene av versjonen av siden du jobber på nå. Den øverste er gjeldende.",
      "RevisionID": "Revisjon-ID",
      "SavedTimestamp": "Lagringstidspunkt",
      "Title": "Tittel",
      "Version": "Versjon",
      "VersionID": "Versjon-ID"
    },
    "Sections": {
      "formData": "Skjemadata",
      "general": "Generelle innstillinger",
      "languageConnections": "Språkkoblinger",
      "newsletters": "Nyhetsbrev",
      "revisions": "Lagringshistorikk",
      "security": "Sikkerhet",
      "versions": "Versjoner"
    },
    "SelectTemplateLabel": "Mal",
    "SelectTemplateButton": "Velg mal",
    "SelectTemplateDisabled": "Krever at siden eller versjonen er et utkast",
    "SelectTemplateDescription": "Her kan du velge blant sider som er lagret som \"mal-sider\". En mal er en side med ferdig oppsett av seksjoner og moduler, men uten innhold (tekst, bilder osv). Vær oppmerksom på at innholdet på den gjeldende siden vil bli overskrevet når du laster inn en mal, derfor er funksjonen kun tigjengelig på sideversjoner som er lagret som et utkast.",
    "VersionsTable": {
      "Choosen": "Valgt (redigeres nå)",
      "Count_one": "{{count}} versjon",
      "Count_other": "{{count}} versjoner",
      "Created": "Opprettet",
      "CreatedBy": "Opprettet av: Navn (Bruker-ID)",
      "Current": "Gjeldende",
      "InfoText": "Her er oversikt over alle versjoner som er opprettet av denne siden. I Museum24 2.0 opprettes det ny versjon hver gang det lagres et nytt utkast av en side som allerede er publisert. Man kan kun jobbe redaksjonelt med gjeldende versjon og utkast nyere enn denne. Versjoner som er eldre enn gjeldende versjon vises som «Erstattet».",
      "No": "Nei",
      "OptVersionTitle": "Versjonstittel",
      "Superseded": "Erstattet",
      "VersionID": "Versjon-ID",
      "VersionStatus": "Versjonsstatus",
      "Yes": "Ja"
    },
    "LanguageConnections": {
      "Intro": "Her kan du legge inn eller fjerne koplinger mellom sider på nettstedets hovedspråk og tilsvarende sider på andre språk. Dette vil da medføre at språkvelger i sluttportal vil gi direktelenker mellom tilsvarende sider på ulike språk. Koplingene vil være to-veis. Dersom ikke koplinger angis så vil språkvelger i sluttportal alltid lenke til annets språks forside.",
      "IntroNotMainLanguage": "Koplinger mellom sider på ulike språk kan kun administreres via sider som er på nettstedets hovedspråk.",
      "ConnectPage": "Koble til side",
      "RemoveConnection": "Fjern kobling",
      "CurrentPageLanguage": "Denne sidens språk",
      "MainLanguage": "Hovedspråk",
      "NoConnection": "Ingen kopling",
      "OtherLanguages": "Andre språk",
      "PageConnections": "Denne siden er koplet med:",
      "ConnectedTo": "Koblet til: {{languages}}"
    },
    "Restore": {
      "Button": "Gjenopprett",
      "ConfirmText": "Vil du gjenopprette innholdet fra {{source}}? Det lages en ny versjon (utkast) med dette innholdet, som må publiseres for å bli synlig. Felter på sidenivå, som adresse, sidetittel og hovedbilde, beholder dagens verdier.",
      "DraftExists": "Siden har allerede et utkast. Publiser eller slett utkastet før du gjenoppretter.",
      "Failed": "Kunne ikke gjenopprette innholdet.",
      "RenameFailed": "Ny versjon ble laget, men versjonstittelen kunne ikke settes.",
      "RevisionLabel": "revisjon {{id}} ({{time}})",
      "Success": "Innholdet er gjenopprettet i en ny versjon.",
      "UnsavedChanges": "Du har ulagrede endringer. Lagre eller forkast dem før du gjenoppretter.",
      "VersionLabel": "versjon {{number}}",
      "VersionTitle": "Gjenopprettet fra {{source}}"
    },
    "Protected": "Beskyttet",
    "ProtectedByParent": "Beskyttet av overordnet side"
  },
  "PageSizeSelector": {
    "NumberOfElementsToShow": "Antall elementer pr. side"
  },
  "PageTree": {
    "NoImportedPages": "Ingen importerte sider venter på plassering",
    "NoPagesFound": "Ingen sider"
  },
  "PageTreeActionMenu": {
    "DeleteWithChildrenQuestion": "Undersidene til denne siden slettes også. Er du sikker?",
    "MenuItems": {
      "Archive": "Arkiver",
      "DeletePage": "Slett",
      "MoveToFolder": "Flytt til mappe...",
      "Preview": "Forhåndsvis",
      "Publish": "Publiser",
      "PublishWithChildren": "Publiser med undersider",
      "ShowInPortal": "Vis i portal",
      "Unpublish": "Avpubliser"
    }
  },
  "PageTreeBulkOperations": {
    "archive": "Arkiver",
    "delete": "Slett",
    "deleteImportedChildrenNote": "Undersider av markerte sider slettes også.",
    "deleteImportedQuestion": "Markerte sider slettes. Er du sikker?",
    "deleteImportedTitle": "Sletter importerte sider",
    "deleteImportedHint": "Ikke lukk vinduet før slettingen er ferdig.",
    "deleteImportedProgress": "Sletter {{done}} av {{total}} sider …",
    "moveEvents": "Flytt arrangementer",
    "movePages": "Flytt sider",
    "publish": "Publiser",
    "publishImportedChildrenNote": "Undersider av markerte sider publiseres også.",
    "publishImportedQuestion": "Markerte sider publiseres og legges på rot i sidetreet. Fortsette?",
    "unpublish": "Avpubliser"
  },
  "PageTreeCheckbox": {
    "Tooltips": {
      "HasChildren": "Hold SHIFT + KLIKK for å velge eller velge bort alle undersider",
      "NotSelectedAndPartiallySelectedChildren": "Denne siden er IKKE valgt, men noen av undersidene er det. $t(PageTreeCheckbox.Tooltips.HasChildren)",
      "SelectedAndPartiallySelectedChildren": "Denne siden, og noen av undersidene, er valgt. $t(PageTreeCheckbox.Tooltips.HasChildren)"
    }
  },
  "PageTreeContent": {
    "HasDraftVersion": "Har utkast",
    "addSubPageButtonLabel": "Ny underside",
    "edit": "Rediger",
    "editEventButtonLabel": "Rediger arrangement",
    "editPageButtonLabel": "Rediger side",
    "missingDate": "Dato mangler",
    "movePagesHereButtonLabel": "Flytt markerte sider under denne"
  },
  "PageTreeFilter": {
    "ClearAllFiltersTooltip": "Fjern alle filtre"
  },
  "PageTreeToolbar": {
    "MovePageToFolderDialog": {
      "Cancel": "Avbryt",
      "ConfirmMove": "Flytt",
      "Title": "Flytt til mappe"
    },
    "filterCategoriesButtonLabel": "Filtrer kategorier",
    "locations": "Steder",
    "noLocationsFound": "Ingen steder funnet",
    "subCategoryLabel": "Kategori",
    "toggleLastEditedButtonLabel": "Sist redigert",
    "toggleSelectionModeButtonLabel": "Marker flere"
  },
  "PreviewWrapper": {
    "PreviewMode": {
      "developer": "Utvikler",
      "normal": "Normal"
    }
  },
  "ProgramBlock": {
    "AddProgramTime": "Legg til programtid",
    "ProgramTimeItem": {
      "Description": "Beskrivelse",
      "From": "Fra",
      "ProgramTime": "Programtid",
      "RemoveProgramTimeItem": "Fjern programtid",
      "Title": "Tittel",
      "To": "Til"
    }
  },
  "QuoteBlock": {
    "byline": "Byline",
    "quote": "Sitat"
  },
  "RadioInput": {
    "NoValue": "Ingen"
  },
  "SearchSelector": {
    "noMatch": "Ingen treff"
  },
  "SectionDirectionSelector": {
    "Tooltip": "Retning",
    "options": {
      "carousel": "Karusell",
      "introbanners": "Beta: IntroBanners",
      "ltr": "Til høyre",
      "rtl": "Til venstre",
      "snappy": "Beta: Snappy Banners"
    }
  },
  "SectionWidthSelector": {
    "Tooltip": "Bredde",
    "options": {
      "article__grid": "Smal",
      "full__grid": "Full",
      "section__grid": "Nettstedsbredde (Bred)",
      "wide__grid": "Middels"
    }
  },
  "SelectButton": {
    "Deselect": "Velg bort",
    "Select": "Velg"
  },
  "SelectInput": {
    "NoSelection": "Ikke valgt"
  },
  "SelectedDMMediaItem": {
    "License": "Lisens",
    "Owner": "Eier"
  },
  "Settings": {
    "LanguageSettings": {
      "404": {
        "404pageMissing": "404-side mangler",
        "addPageButton": "Plukk side",
        "pagenotfoundInfoMessage": "Benyttes kun hvis 404-side mangler",
        "pagenotfoundText": "\"Side ikke funnet\"-tekst",
        "pagenotfoundTitle": "\"Side ikke funnet\"-tittel",
        "title": "404 - Side ikke funnet"
      },
      "keypages": {
        "addPageButton": "Plukk side",
        "dmFilterPage": "DigitaltMuseum filter-side",
        "dmFilterPageInfo": "Denne siden skal inneholde en DigitaltMuseum-filtermodul som er satt opp til å vise søketreff fra DigitaltMuseum. Sluttbruker vender tilbake til denne når hen søker via klikk på steder, nøkkelord el. i en integrert DigitaltMuseum fullvising"
      },
      "LanguageCreationView": {
        "description": "Kort beskrivelse",
        "languagetext": "Språk",
        "languagetextPlaceholder": "Eks \"Norwegian\"",
        "name": "Navn på nettsted på dette språk"
      },
      "LanguageFooterSettings": {
        "address": "Adresse",
        "addressLabel": "Ledetekst",
        "addressTitle": "Adresse og info",
        "addressesTitle": "Ekstra adresser",
        "copyright": "Copyright",
        "editor": "Redaktør",
        "editorLabel": "Redaktør (overskrift)",
        "email": "E-post",
        "emailLabel": "E-post (overskrift)",
        "infoText": "Adresser og kontakinformasjon i footer kan legges inn her for å håndtere oversettelser.\nDet kan også legges til flere adresselinjer.",
        "info_deprecated": "Utdatert infofelt fra 1.0 (footer). Legge i stedet lenker/data inn i footerinnstilliinger.",
        "link": "Lenke til kontaktinformasjon",
        "menu": {
          "cssClass": "CSS-klasse",
          "includeNavPath": "Inkluder søkefelt i footer (bruker søk-innstillinger fra header)",
          "includeSearchField": "Inkluder navigasjonssti i footer",
          "menuPointTitle": "Tittel på menypunkt",
          "subMenu": "Undermeny"
        },
        "menuTitle": "Header / Meny",
        "name": "Navn/Museumsnavn",
        "openInNewWindow": "Åpne i nytt vindu/fane",
        "orgNumber": "Org-nummer",
        "orgNumberLabel": "Org-nummer (overskrift)",
        "phone": "Telefonnummer",
        "phoneLabel": "Telefon (overskrift)",
        "postalCode": "Postnummer",
        "postalPlace": "Poststed",
        "privacyLink": "Link til personvern",
        "privacyLinkLabel": "Tekst for personvernlink",
        "privacySettingsLabel": "(KIT CCM) Personverninnstillinger linktekst",
        "responsibleEditor": "Ansvarlig redaktør",
        "responsibleEditorLabel": "Ansvarlig redaktør (overskrift)",
        "transparencyActLink": "Link til åpenhetsloven",
        "transparencyActLinkLabel": "Tekst for link til åpenhetsloven",
        "social": {
          "facebook": "Facebook",
          "flickr": "Flickr",
          "instagram": "Instagram",
          "linkedin": "LinkedIn",
          "pinterest": "Pinterest",
          "textFieldLabel": "Tekst",
          "textFieldPlaceholder": "Besøk oss på...",
          "tripadvisor": "TripAdvisor",
          "twitter": "Twitter",
          "vimeo": "Vimeo",
          "youtube": "YouTube",
          "tiktok": "TikTok"
        },
        "socialTitle": "Sosial deling",
        "text": "Fritekst",
        "uuLink": "Link til tilgjengelighetserklæring",
        "uuLinkLabel": "Tekst for tilgjengelighetserklæring"
      },
      "LanguageInfoSettings": {
        "defaultLanguage": "Sett som hovedspråk",
        "pageInfo": {
          "description": "Kort beskrivelse",
          "name": "Navn på nettsted",
          "title": "Nettstedsinformasjon",
          "overrideLocale": "Overstyr språk-kode",
          "translations": "Diverse oversettelser",
          "KulturPunktLabel": "Kulturpunkt",
          "KulturPunktHitsLabel": "Kulturpunkt treff"
        }
      },
      "LanguageLogoSettings": {
        "logoEcoLighthouse": "Miljøfyrtårnlogo (Sertifisert bedrift)",
        "logoEcoLighthouseLink": "Link til Miljøfyrtårninfo (intern eller ekstern)",
        "logoConsolidatedFooter": "Logo konsolidert footer (SVG)",
        "logoConsolidatedHeader": "Logo konsolidert header (SVG)",
        "logoFooter": "Logo footer (SVG)",
        "logoFooterGlobal": "Logo footer (SVG): Språkuavhengig. Språkspesifikk kan angis under språkinnstillinger og vil da overstyre denne",
        "logoHeader": "Logo header (SVG)",
        "logoHeaderGlobal": "Logo header (SVG): Språkuavhengig. Språkspesifikk kan angis under språkinnstillinger og vil da overstyre denne",
        "logoTitle": "Logotittel med linjebruddsstøtte",
        "parentUrl": "Link til konsolidert museum",
        "svgCode": "SVG-kode",
        "parentName": "Navn på konsolidert museum",
        "parentText": "Tekst over logo"
      },
      "LanguageMenuSettings": {
        "addPageButton": "Plukk side",
        "availableLanguages": "Tilgjengelige språk",
        "consolidatedInfo": "Konsolidert informasjon",
        "consolidatedLink": "Konsolidert URL",
        "consolidatedLine": "Konsolidert linje tekst",
        "consolidatedLogo": "Konsolidert logo (SVG)",
        "consolidatedName": "Navn på konsolidert museum",
        "cssClass": "CSS-klasse",
        "focusMenu": "Fokusmeny",
        "includeConsolidatedLine": "Vis konsolidert linje",
        "includeConsolidatedLogo": "Vis konsolidert logo",
        "includeInfoLine": "Vis infolinje",
        "infoLineFrontPageOnly": "Vis kun på forsiden",
        "includeLanguageMenu": "Vis språkmeny",
        "includeSearchButton": "Vis søkeknapp i søkefelt",
        "includeSearchField": "Vis søkefelt",
        "infoLine": "Info-linje",
        "infoLineText": "Tekst i infolinje",
        "infoLineButtonText": "Tekst i infolinje-knapp/tekstlenke",
        "infoLineShowAsLink": "Vis som tekstlenke på alle skjermstørrelser",
        "infoLineLink": "Link (url) i infolinje",
        "infoLineSkin": "Farge (skin) på infolinje",
        "languageMenu": "Språkmeny",
        "languageTitleInMenu": "Tittel på språk i meny",
        "languagesInMenu": "Språkmeny (i ønsket rekkefølge)",
        "mainMenu": "Hovedmeny",
        "menuPointTitle": "Tittel på menypunkt",
        "searchButtonText": "Tekst i søkeknapp",
        "searchField": "Søkefelt",
        "searchFieldText": "Tekst i søkefelt",
        "searchresultPage": "Søkeresultatside",
        "subMenu": "Undermeny",
        "url": "Url"
      },
      "SEO": {
        "description": "SEO Beskrivelse (meta-tag)",
        "keywords": "SEO Stikkord (meta-tag)",
        "title": "Søkeoptimalisering",
        "enableSitemap": "Aktiver automatisk sitemap.xml for dette språket"
      },
      "childCount_one": "1 underpunkt",
      "childCount_other": "{{count}} underpunkter",
      "childCount_zero": "Ingen underpunkter"
    },
    "SiteSettings": {
      "SiteCategoriesSettings": {
        "Info": {
          "Clarification": "Kategorier fra tidligere ble hovedsakelig brukt for å enkelt kunne hente ut sider/kort automatisk. Dette kan nå løses med moduler for automatisk (og manuell) sideutlisting, slik at tidligere kategorier nå er overflødige.",
          "Definition": "KATEGORIER er nå forhåndsdefinert i Museum24. Dette for å enklere kunne bruke kategorier på tvers av nettsider. Noen kategorier har også underkategorier for bedre filtreringsmulighet. \"Arrangement\" har også blitt en egen sidetype.",
          "ReadMoreCategories": "Les mer om kategorier",
          "ReadMoreEvents": "Les mer om Arrgangement som ny sidetype",
          "ReadMorePageListing": "Les mer om sideutlisting"
        }
      },
      "SiteKeywordsSettings": {
        "deleteConfirm": "Er du sikker på at du vil slette?",
        "displayOnlyUnused": "Vis kun stikkord som ikke er i bruk",
        "infoText": "Stikkord kan opprettes og påføres innhold for å skape lettere gjenfinning, samt. muligheter for søk etter innhold med gitte stikord ut mot sluttbruker. Her kan dere administrere stikkord, fjerne stikkord som ikke bør brukes, fikse feilstavelser, duplikater o.l. Nedenfor listes alle tagger som er opprettet for dette nettsteder. Mens du skriver inn ny tag, vil du i listen nedenfor kunne se om denne allerede finnes.",
        "newCardCategory": "Søk, eller legg til ny kort-kategori",
        "newKeyword": "Søk, eller legg til nytt stikkord",
        "sorting": "Sortering",
        "tag": "Stikkord"
      },
      "SiteLocationsSettings": {
        "changeCoordinates": "Endre koordinater",
        "deleteConfirmBody": "Er du sikker på at du vil slette dette stedet?",
        "deleteConfirmTitle": "Slett sted",
        "full_address": "Full adresse",
        "infoText": "Steder du oppretter her vil du kunne finne igjen og knytte til annet innhold som du ønsker å stedsfeste",
        "missingTitle": "Stedsnavn mangler",
        "postal_code": "Postnummer",
        "postal_town": "Sted",
        "street_name": "Gate",
        "titleInputLabel": "Navn på sted/lokasjon"
      },
      "SitePageTemplateSettings": {
        "deleteTemplateError": "Det skjedde en feil ved sletting av mal",
        "deleteTemplateSuccess": "Mal slettet",
        "editTemplateButton": "Rediger mal",
        "infoText": "Maler lar deg lagre oppsettet fra en eksisterende side, og raskt opprette lignende sider.",
        "readMoreLabel": "Les mer om maler her"
      },
      "SiteSharingSettings": {
        "Events": {
          "title": "Eksport av arrangementer (JSON)",
          "intro": "URLen nedenfor leverer dette nettstedes kommende arrangementer (inntil ett år frem i tid) ut som JSON-data for import hos andre tjenester. Dataformatet som vi tilbyr er utviklet spesfikt for eksport til Visit-tjenester i Norge (driftet av SimpleView). Dersom man vil eksportere fra flere nettsteder via en og samme url må man sende med ID til disse nettstedene kommaseparert i URLen via ?site_id=ID1,ID2,osv. Dersom du velger ett annet nettstedsspråk i språkvelger oppe til høyre vil du også få en URL til uthenting av arrangementer på dette språket."
        },
        "SharingContentType": {
          "content": "Innhold (sider, kort, arrangementer, ansatte)",
          "label": "Innholdstype",
          "resources": "Media",
          "templates": "Maler"
        },
        "SiteSharingSettingsNewAgreementModal": {
          "selectSite": "Velg site",
          "titles": {
            "given": "Gi ny tilgang til:",
            "granted": "Søk om ny tilgang til:"
          }
        },
        "accessToX": "Dere har tilganger til: ({{x}})",
        "addNewAccess": "Ny tilgang",
        "addNewApplication": "Ny søknad",
        "contentType": "Innholdstype",
        "sharingWithX": "Dere deler med: ({{x}})",
        "unsavedChanges": "Du har ulagrede endringer! Trykk på 'Lagre' for å bekrefte endringene."
      }
    },
    "WebpageSettings": {
      "General": "Generelt",
      "SiteID": "Nettsteds ID",
      "SiteName": "Nettstedsnavn / Beskrivelse",
      "SiteDefaultLanguage": "Standard språk",
      "SiteUrl": "Nettsteds URL",
      "WebpageEKulturIntegrationsSettings": {
        "title": "E-kultur integrasjoner",
        "digitaltMuseum": "DigitaltMuseum",
        "dmOwners": "DigitaltMuseum eierkoder",
        "dmIncludedInSiteSearch": "Inkludér treff fra DigitaltMuseum i nettstedets søk",
        "dmIntegratedView": "Integrert visning av DigitaltMuseum objekter i søkeresultat",
        "kulturPunkt": "KulturPunkt",
        "kulturpunktOwnerID": "KulturPunkt MuseumsID",
        "kpComplete": "Vise hele kulturpunktet ved integrert visning",
        "kulturpunktIncludedInSiteSearch": "Inkludér treff fra KulturPunkt i nettstedets søk"
      },
      "WebpageIconsSettings": {
        "title": "Ikoner og logoer",
        "logoDescription": "Logo for header og footer som vises på alle ulike språk. Dersom logo skal være ulik på ulike språk med disse legges inn under språkinnstillinger",
        "addFileButtonLabel": "Legg til logofil",
        "favicon": "Fav-ikon",
        "faviconCaption": "Lite bilde/ikon som vises i fanen i nettleseren",
        "noImageChosen": "Ingen valgt",
        "touchicon": "Nettstedets touch-ikon",
        "touchiconCaption": "Ikon hvis noen lager snarvei på sin smarttelefon",
        "otherIconSettings": "Andre iconinnstillinger",
        "disableEkulturMapPin": "Bruk standard kart-pin",
        "disableKPmapPin": "Ikke bruk KP-kart-pin",
        "disableDMmapPin": "Ikke bruk DM-kart-pin"
      },
      "WebpageConsentSettings": {
        "title": "Samtykkehåndtering",
        "gdprScripts": "Script fra andre leverandører (usersentric, cookiebot o.l.)",
        "KitCMP": "Standard Ekultur samtykkeløsning (UNDER UTVIKLING)",
        "KitCMPdescription": "Denne konfigureres via Ekultur sin administrasjonsløsning for samtykkehåndtering pr. domene (nettsted). Løsningen vil bli tilgjengelig for bruk når den er ferdig utviklet.",
        "KitCMPisActive": "Ekultur samtykkeløsning er aktivert for dette nettstedet",
        "KitCMPisInactive": "Ekultur samtykkeløsning er ikke aktivert for dette nettstedet",
        "activateKitCMP": "Aktiver Ekultur samtykkeløsning",
        "activateKitCMPbutton": "Vis flytende knapp for personverninnstillinger",
        "enableGdprInTestEnvironments": "Tillat samtykkeløsningsscript (Ekulturs eller ekstern) i TEST-miljø",
        "KitCMPTestScript": "TestScript (for å teste at samtykkeløsningen mens den er under utvikling)",
        "OtherCMP": "Annen samtykkeløsning (Usercentrics, Cookiebot eller liknende)",
        "OtherCMPDescription": "Dersom dere vil benytte en 3.parts samtykkeløsning kan KulturIT legge inn script for dette.",
        "OtherCMPscript": "Script for annen samtykkehåndtering",
        "OtherCMPisActive": "Annen samtykkeløsning er aktivert for dette nettstedet"
      },
      "WebpageTrackingSettings": {
        "title": "Sporing",
        "facebook": "Facebook",
        "facebookDomainVerification": "Facebook Domain Verify",
        "facebookDomainVerificationCaption": "Legg kun inn din domeneverifikasjonsID",
        "facebookDomainVerificationPlaceholder": "En streng med tall og bokstaver",
        "facebookPixcelCode": "Facebook/Meta Pixel ID",
        "facebookPixcelCodeCaption": "Legg kun inn din pixel code-\"ID\"",
        "facebookPixcelCodePlaceholder": "Eks. 123456789",
        "google": "Google",
        "googleGtagKey": "Google Analytics 4 Key",
        "googleMapsKey": "Kart: Google Maps Key",
        "googleMapsKeyPlaceholder": "Hvis egen key for dette nettstedet",
        "googleSiteVerification": "Google Site Verification UID (Webmastertools)",
        "googleTagmanagerKey": "Google Tagmanager Key",
        "enableStructuredGoogleBreadcrumbs": "Aktiver Google-strukturerte data for navigasjonssti/sidestruktur",
        "enableStructuredGoogleEvents": "Aktiver Google-strukturerte data for arrangementer",
        "plausible": "Plausible (Standard Museum24 sporing uten informasjonskapsler)",
        "plausibleDescription": "Standard sporing for nettsteder i Museum24. Ingen informasjonskapsler, ingen personopplysninger. Statistikk integrert i Museum24 adminklient.",
        "plausibleEnable": "Slå på Plausible sporing",
        "plausibleEnabled": "Plausible er aktivert for dette nettstedet",
        "plausibleNotEnabled": "Plausible er ikke aktivert for dette nettstedet",
        "plausibleWebsiteId": "Plausible Website ID (hvis annet enn nettstedets domene)",
        "plausibleExtraTrackerId": "Plausible ekstra Tracker ID (f.eks for felles tracking på tvers av domener i en konsolidering)",
        "plausibleAuth": "AUTH kode for Plausible Dashboard embed/share URL",
        "plausibleScriptId": "Plausible Script ID (nytt opplegg for å inkludere script fra okt. 25)",
        "plausibleUniqueDomain": "Huk av hvis ingen andre nettsteder bruker samme domene",
        "plausibleEnableLocalhostTracking": "Aktiver sporing på localhost (for testing lokalt)"
      },
      "WebpageSearchSettings": {
        "title": "Utvidet søkeoppsett (for nettstedssøket)",
        "description": "Hvilke andre nettsteder ønsker du å kunne gjøre søk mot?",
        "availableSites": "Tilgjengelige site'er basert på delingsavtaler",
        "search": "Søk",
        "siteSearchAsync": "Bruk asynkront søk"
      },
      "WebpageSystemSettings": {
        "title": "Systeminnstillinger",
        "description": "Scripts (Nyhetsbrev og liknende). Kun tilgjengelig for superadmins.",
        "gdprScripts": "GDPR-scripts",
        "scripts": "Scripts/Styles (Header)",
        "footerScripts": "Scripts (At bottom)",
        "diverse": "Diverse innstillinger",
        "cssClass": "CSS-klasser (body)",
        "siteIsNotAphysicalLocation": "Dette nettstedet er ikke et fysisk sted (vises ikke på arrangementer)",
        "dmChannel": "Dette nettstedet er en DigitaltMuseum kanal"
      },
      "WebpageContactInfoSettings": {
        "title": "Kontaktinformasjon (språkuavhengig)",
        "description": "Kontaktinformasjon som vises i footer. Kan overstyres under footerinnstillinger per språk."
      }
    },
    "titles": {
      "404": "404-side",
      "categories": "Kategorier",
      "create": "Legg til nytt språk",
      "eKulturIntegrations": "eKultur-integrasjoner",
      "footer": "Footer",
      "footerMenu": "Footermeny",
      "keypages": "Nøkkelsider",
      "keywords": "Stikkord",
      "language": "Språk",
      "languageInfo": "Informasjon",
      "locations": "Steder",
      "logo": "Logo",
      "menu": "Header / Meny",
      "seo": "SEO / Meta",
      "sharing": "Tilganger og delinger",
      "site": "Siteinnstillinger",
      "tracking": "Sporing og koblinger",
      "users": "Brukere",
      "webpage": "Nettstedsinnstillinger",
      "webpageIcons": "Nettstedsikoner",
      "webpageInfo": "Nettstedsinformasjon"
    }
  },
  "SiteSelector": {
    "selectOrChangeActiveSite": "Velg eller bytt aktivt nettsted",
    "selectOrChangeActiveSiteLanguage": "Velg eller bytt språk for aktivt nettsted"
  },
  "SiteSharingBlockSettings": {
    "MuseumSharingInfo": "Mangler du museer? Sjekk delingsavtaler",
    "SelectAll": "Velg alle",
    "SelectSites": "Velg hvilke museer du vil filtrere på",
    "UnselectAll": "Fjern valgte"
  },
  "SiteUsersSettings": {
    "name": "Navn",
    "email": "Epost",
    "role": "Rolle"
  },
  "SkinSelector": {
    "SelectSkinTooltip": "Velg Skin"
  },
  "SortMenu": {
    "Asc": "Stigende",
    "Date": "Sist endret",
    "Desc": "Synkende",
    "SortBy": "Sorter etter",
    "SortDirection": "Retning",
    "SortMenuTooltip": "Sorter sider",
    "Status": "Status",
    "Title": "Tittel"
  },
  "TableBlock": {
    "AddRow": "Legg til rad",
    "ColAsHeader": "Bruk første kolonne som tittelkolonne",
    "ConfirmParseTable": "Er du sikker på at du vil konvertere tabellen? Eksisterende innhold vil bli overskrevet.",
    "DisplayState": {
      "collapsed": "Minimert",
      "expanded": "Ekspandert"
    },
    "NoBorder": "Ingen kantlinje",
    "StripedHorizontal": "Kun horisontale linjer",
    "FooterText": "Footertekst",
    "HideInputField": "Skjul felt for å lime inn eksterne tabeller",
    "InitialStatePlaceholder": "Visningstilstand",
    "InputFieldPlaceholder": "Kopier og lim inn tabell fra nettside, regneark el.",
    "NrOfColumns": "Antall kolonner",
    "ParseWithComma": "Lag tabell med komma som skilletegn",
    "ParseWithTab": "Lag tabell med tab som skilletegn",
    "RowAsHeader": "Bruk første rad som tittelrad",
    "SelectInitialState": "Velg hvordan tabellen først skal vises",
    "ShowInputField": "Vis felt for å lime inn eksterne tabeller"
  },
  "TextBlock": {
    "HideBodyText": "Skjul brødtekst og vis ved klikk på tittel",
    "IconHelpText": "Icon vises kun i tekstboks visning",
    "TextEditorType": "Bytt teksteditor",
    "TitleOverLinkList": "Tittel over lenkeliste",
    "localCaption": "Lokal bildetekst",
    "localCaptionDescription": "Overstyrer global bildetekst"
  },
  "ToggleExpandAllButton": {
    "ContractAll": "Komprimér alle",
    "ExpandAll": "Utvid alle"
  },
  "ToggleSelectAllCheckbox": {
    "CountItemsSelected_one": "{{count}} side er valgt",
    "CountItemsSelected_other": "{{count}} sider er valgt",
    "DeselectAll": "Velg bort alle",
    "SelectAll": "Velg alle"
  },
  "UserAvatarMenu": {
    "siteRole": "Din ekultur-rolle:",
    "logOut": "Logg ut",
    "ownerSettings": "Innstillinger for eier ({{owner}})",
    "settings": "Innstillinger for nettsted ({{site}})"
  },
  "ViewTypeSelector": {
    "SelectViewTypeVariant": "Velg visningstype",
    "SelectViewTypeWidth": "Velg bredde",
    "ViewTypeWidth": {
      "full": "Nettstedsbredde",
      "narrow": "Smal",
      "none": "Auto",
      "wide": "Bred"
    }
  },
  "WidgetBlock": {
    "height": "Iframe høyde",
    "html": "HTML-kode (SVG, enkle HTML-tagger, innbygningskode/iframes fra 3.part, 3.parts JS-widgets/script)",
    "isWidget": "Dette er javascript-kode",
    "src": "Iframe SRC (url)",
    "width": "Iframe bredde",
    "iframeSettings": "Innstillinger for iframe",
    "additionalSettings": "Tilleggsinnstillinger",
    "externalUrl": "Ekstern URL (visning av innholdet hos 3.parts tjeneste)",
    "widgetDescription": "Beskriv tjeneste med et par ord",
    "convert": "Konverter Widget",
    "convertInfo": "Dersom Widget er benyttet for 3.parts lyd/videotjenester (Soundcloud, Spotify, YouTube o.l.) kan du her konvertere den til ny lyd/video-modul. Dette vil systematisere innholdet på nettstedet bedre. Data som ligger i modulen vil automatisk bli tatt med inn i den nye modulen.",
    "convertConfirm": "Er du sikker på at du vil konvertere denne widgeten?",
    "convertToAudio": "Konverter til LYD-modul",
    "convertToVideo": "Konverter til VIDEO-modul",
    "securityInfo": "<strong>VIKTIG:</strong> Her skal den KUN legges inn kode fra trygge og verifiserte kilder og tredjepartsleverandører. Hvis du er usikker på koden så ta kontakt med KulturIT for vurdering og veiledning. KulturIT vil også kjøre jevnlige sjekker av innholdet i Widget-modulen for å vurdere sikkerheten.<br/><br/>NB! Museum24 har egne moduler for Audio og Video, så benytt disse for audio og video. Widget-modulen kan også enkelt konverteres til en audio- eller videomodul. Se helt i bunnen av modulen."
  },
  "AudioBlock": {
    "title": "Tittel",
    "file": "Filnavn",
    "source": "Lydkilde",
    "sourceEkultur": "Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "Ekstern (Soundcloud, Spotify eller lignende)",
    "provider": "Lydleverandør",
    "other": "Annet",
    "providerHelpText": "Velg en leverandør for lyden. Hvis du ikke finner leverdøren her, velg Annet og meld fra til KulturIT om dette.",
    "m24Sound": "Lyd fra Museum24 galleri",
    "pickM24Sound": "Plukk lyd fra Museum24 galleri",
    "pickDMSound": "Plukk objekt med lyd fra DigitaltMuseum",
    "localTitle": "Tittel (hvis annet enn det som ligger i objektet)",
    "localCaption": "Beskrivelse (hvis annet enn det som ligger i objektet)",
    "disableCredits": "Skjul credits",
    "securityInfo": "<strong>VIKTIG:</strong> Her skal det KUN legges inn kode fra trygge og verifiserte kilder og tredjepartsleverandører. Velg tilbyder fra nedtrekkslisten. Hvis du er usikker på koden så ta kontakt med KulturIT for vurdering og veiledning.",
    "layouts": {
      "simple": "Enkel",
      "normal": "Normal",
      "extended": "Utvidet"
    }
  },
  "VideoBlock": {
    "source": "Videokilde",
    "sourceEkultur": "Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "Ekstern (YouTube, Vimeo eller lignende)",
    "provider": "Videoleverdør",
    "other": "Annet",
    "providerHelpText": "Velg en leverandør for videoen. Hvis du ikke finner leverdøren her, velg Annet og meld fra til KulturIT om dette.",
    "m24Video": "Video fra Museum24 galleri",
    "pickM24Video": "Plukk video fra Museum24 galleri",
    "pickDMVideo": "Plukk objekt med video fra DigitaltMuseum",
    "localTitle": "Tittel (hvis annet enn det som ligger i objektet)",
    "localCaption": "Beskrivelse (hvis annet enn det som ligger i objektet)",
    "disableCredits": "Skjul credits"
  },
  "ReferencesBlock": {
    "addReference": "Legg til referanse/kilde",
    "referenceLabel": "Referanse/kilde",
    "referencePlaceholder": "Skriv inn referanse her",
    "date": "Dato/år (Utgitt, Lastet ned, Lest)",
    "media": "Media (Tidsskrift, avis, bok, nettsted, evnt. oppgave)",
    "issue": "Utgave/Ant. bind (nr./år)",
    "pageNumber": "Sidenummer",
    "publisher": "Forlag/Utgiver (evnt. skole)",
    "place": "Sted/Land",
    "author": "Forfatter(e) / Redaktør(er) / ID på dokument el.",
    "editor": "Redaktør",
    "title": "Tittel på arbeid",
    "url": "URL (nettadresse)",
    "accessedDate": "Dato besøkt",
    "sitename": "Nettstedsnavn",
    "doi": "DOI (Digital Object Identifier)",
    "referenceType": "Referansetype",
    "referenceNumber": "Ref.nr",
    "reportNumber": "Rapportnr",
    "referenceTypeOptions": {
      "article": "Artikkel",
      "book": "Bok",
      "chapter": "Kapittel",
      "document": "Dokument",
      "film": "Film",
      "interview": "Intervju",
      "map": "Kart",
      "newspaper": "Avis",
      "report": "Rapport",
      "website": "Nettsted",
      "other": "Annet"
    }
  },
  "common": {
    "setAsPageMainImage": "Bruk som hovedbilde for siden"
  }
}
